<!--
* @Author: Q in 
* @Date: 2026-03-10 09:45:05
 * @LastEditors: Q in 
 * @LastEditTime: 2026-10-28 14:33:05
* @FilePath: /new_kefu_pc/src/App-index.vue
* @Description: 客户端根组件 - 客服浮标和聊天窗口
-->
<template>
	<!-- 客服容器，支持拖拽 -->
	<div id="kefu-container" @mousedown="startDrag">
		<!-- 客服浮标 -->
		<template v-if="wsConnected">
			<div class="kefu_button_container" :class="{ 'kefu-button-pressed': kefuButtonPressed, 'kefu-button-active': kefuButtonActive }" style="width: 140px; height: 140px;" v-show="kefuButtonVisible" ref="buttonContainer">
                <transition name="el-fade-in-linear">
					<div class="unread-messages-count" v-show="unreadMessagesCount">{{ unreadMessagesCount }}</div>
				</transition>

				<img class="kefu_button_img pointer" src="https://images.xianyouhe.com/kefu/new-kefu/icon-logo.png" alt="客服浮标" @mousedown="kefuButtonPressed = true" @mouseup="kefuButtonPressed = false" @mouseleave="kefuButtonPressed = false" @click="onClickShowKefu" />

				<transition name="el-fade-in-linear">
					<div class="new-message" v-show="tipVisible">
						<div class="new-message-text ellipsis-2">{{ tipContent || '' }}</div>
					</div>
				</transition>
			</div>
		</template>

		<!-- 聊天窗口，带缩放打开动画 -->
		<transition name="kefu-zoom" @after-leave="onChatAfterLeave">
			<div class="chat-container flex" v-show="showKefuButton" :style="chatOriginStyle">
				<div class="chat-sidebar">
					<div class="search-container">
						<div class="logo-container">
							<img class="logo" src="https://images.xianyouhe.com/uploads/20260104/166349e43d0aa7f68a5353332e515e8e.png" alt="客服中心" />
						</div>

						<div class="search-wrapper">
							<el-input prefix-icon="el-icon-search" v-model="inputValue" placeholder="搜索" clearable></el-input>
						</div>
					</div>

					<div class="kefu-tab-header flex">
						<div class="kefu-tab-item pointer" :class="{ active: tab.id == activeTab }" v-for="tab in tabs" :key="tab.id" @click="activeTab = tab.id">
							{{ tab.name }}
							<div class="icon-underline"></div>
						</div>
					</div>

					<ul class="kefu-list">
						<template v-for="item in session_list[activeTab] || []">
							<li v-if="(item.session_type == 1 ? item.session_name : item.name).includes(inputValue)" class="kefu-item pointer flex items_center" :class="{ active: activeSession.id == item.id }" :key="item.id" @click="onClickKefu(item)">
								<div class="avatar-container m-right-14" :class="{ 'avatar-mask': item.csr_status == 2 && item.session_type == 0 }">
									<div class="avatar-group" :class="{ 'avatar-group-1': item.session_type == 1 }">
										<template v-if="item.session_type == 1">
											<img v-for="sub in item.session_members" :key="sub.id" :src="sub.avatar" :alt="sub.name" />
										</template>
										<template v-else>
											<img :src="item.avatar" :alt="item.name" />
										</template>
									</div>
	
									<div class="unread_msg_count" v-show="item.unread_msg_count > 0">{{ item.unread_msg_count }}</div>
								</div>
								<div class="info-container">
									<div class="flex items_center jus_spb m-bottom-4">
										<div class="flex">
                                            <div class="name ellipsis-1 m-right-4" :style="{'max-width': item.session_type == 1 ? '130px' : '100px'}">{{ item.session_type == 1 ? item.session_name : item.name }}</div>
                                            <div v-if="item.session_type == 0" class="status-icon p-left-10" :class="[item.csr_status == 1 ? 'pending' : item.csr_status == 2 ? 'offline' : 'online']">{{ item.csr_status == 1 ? '繁忙' : item.csr_status == 2 ? '离开' : '在线' }}</div>
                                        </div>
										<img class="official-icon" src="https://images.xianyouhe.com/kefu/new-kefu/icon-official.png" alt="官方客服" />
									</div>
                                    
                                    <div class="flex items_center jus_spb" style="width: 100%; gap: 10px">
                                        <div class="last-message ellipsis-1" :class="{ highlight: item.message_type == 10 }">{{ item.last_message }}</div>
                                        <div class="last-time">{{ item.last_time }}</div>
                                    </div>
								</div>
							</li>
						</template>

						<div v-show="session_list[activeTab]?.length == 0" class="empty-container flex items_center jus_center">
							<img class="empty-img" src="https://images.xianyouhe.com/kefu/new-kefu/empty.png" alt="" />
						</div>
					</ul>
				</div>

				<div class="chat-content flex_column">
					<div class="chat-header flex items_center jus_spb">
						<div class="header-left flex items_center">
							<div class="shop-name ellipsis-1 m-right-16 p-right-35">
								{{ activeSession.session_type == 1 ? activeSession.session_name : activeSession.name }}
								<div v-if="activeSession.session_type == 0" class="status-icon" :class="[activeSession.csr_status == 1 ? 'pending' : activeSession.csr_status == 2 ? 'offline' : 'online']">
									{{ activeSession.csr_status == 1 ? '繁忙' : activeSession.csr_status == 2 ? '离开' : '在线' }}
								</div>
							</div>
							<div class="kefu-tag m-right-12">金牌客服</div>
							<div class="shop-time">09:00-02:00</div>
						</div>
						<div class="header-right pointer" @click="hideChat">
							<i class="el-icon-close"></i>
						</div>
					</div>

					<!-- PUBG商品详情页，自动发送的商品 -->
					<div class="auto-send-product automatically-send-product flex" v-if="automaticallyProductShow">
						<img class="automatically-send-product-img m-right-20" :src="automaticallyProductInfo.pic_image" :alt="automaticallyProductInfo.name">
						<div class="automatically-send-product-info">
							<div class="automatically-send-product-info-name ellipsis-1 m-bottom-5">{{ automaticallyProductInfo.name }}</div>
							<div class="automatically-send-product-info-tag ellipsis-1 m-bottom-5">{{ automaticallyProductInfo.arm_tabs }}</div>
							<div class="automatically-send-product-info-number">商品编号：{{ automaticallyProductInfo.number }}</div>
							<div class="automatically-send-product-info-price">
								<span>¥ </span>{{ automaticallyProductInfo.price }}
							</div>
						</div>
						<div class="btn-container flex items_end m-left-30">
							<i class="close-btn el-icon-close pointer" @click="onClickAutomaticallyProductClose"></i>
							<el-button size="mini" type="primary" @click="sendProduct(automaticallyProductInfo, 9, 4)">发送商品</el-button>
						</div>
					</div>

                    <!-- 三角洲商品详情页，自动发送的商品 -->
                    <!-- <div class="auto-send-product autodelta-send-product">
                        <div class="autodelta-send-product-number m-bottom-5">商品编号：XYH_1252</div>
                        <div class="flex" style="width: calc(100% - 80px - 30px);">
                            <div class="autodelta-send-product-info flex" style="width: 100%;">
                                <img class="autodelta-send-product-info-image m-right-20" :src="'https://images.xianyouhe.com/uploads/20260415/ff75a3c57acdee3b48260e68afb8a0c2.png'" :alt="''">
                                <div style="width: calc(100% - 150px);">
                                    <div class="autodelta-send-product-info-name ellipsis-1 m-bottom-5">
                                        这是一个欢迎新用户的消息,系统为用户成功分配客服后,
                                        这是一个欢迎新用户的消息,系统为用户成功分配客服后,
                                    </div>
                                    <div class="autodelta-send-product-info-timer">创建时间：2026-07-23 13:39:35</div>
                                    <div class="autodelta-send-product-info-money flex m-top-4" style="gap: 5px">
                                        <div class="flex" style="flex: 1;">
                                            <div class="autodelta-send-product-info-money-lable">租金：</div>
                                            <div class="autodelta-send-product-info-money-value">1000元</div>
                                        </div>
                                        <div class="flex" style="flex: 1;">
                                            <div class="autodelta-send-product-info-money-lable">手续费：</div>
                                            <div class="autodelta-send-product-info-money-value">1000元</div>
                                        </div>
                                    </div>
                                    <div class="autodelta-send-product-info-money flex m-top-5" style="gap: 5px">
                                        <div class="flex" style="flex: 1;">
                                            <div class="autodelta-send-product-info-money-lable">押金：</div>
                                            <div class="autodelta-send-product-info-money-value">1000元</div>
                                        </div>
                                        <div class="flex" style="flex: 1;">
                                            <div class="autodelta-send-product-info-money-lable">实收租金：</div>
                                            <div class="autodelta-send-product-info-money-value">1000元</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="autodelta-send-product-footer flex items_end m-left-30">
                                <i class="close-btn el-icon-close pointer"></i>
                                <el-button size="mini" type="primary">发送商品</el-button>
                            </div>
                        </div>
					</div> -->

					<!-- 聊天记录区域 -->
					<div class="chat-messages flex_column" @scroll="handleScroll" ref="chatMessages">
						<!-- 加载更多提示 -->
						<div class="loading-more" v-show="session_messages.length">
							<i v-show="loadingMessages" class="el-icon-loading"></i>
							<template v-if="pageParams.next_page == 'done'">没有更多了</template>
							<template v-else-if="loadingMessages">加载中...</template>
						</div>

						<template v-for="item in session_messages">
							<div class="message-system" :key="item.id" v-if="item.message_type == 3 || item.message_type == 10 || item.message_type == 11 || item.message_type == 12">{{ item.message }}</div>

							<template v-else>
								<div class="message-item" :class="['message-item-' + item.sender]" :key="item.id">
									<div class="flex">
										<div class="avatar-container m-right-14" v-if="item.sender == 'you'">
											<img :src="item.avatar" :alt="item.name" />
										</div>

										<div class="message-content">
											<div class="message-info flex items_center" v-if="item.sender == 'you'">
												<div class="message-name" :class="{ pointer: activeSession.session_type == 1, 'multi-user': activeSession.session_type == 1 }" @click="onClickMultiUser(item)">{{ item.name }}</div>
												<div class="message-time m-left-10">{{ item.createtime_text }}</div>
											</div>

											<div class="message-text m-top-2" v-if="item.message_type == 0" @contextmenu.prevent.stop="handleRightClick(item)">
												<ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

												<div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>
												<div class="message-text-content" v-html="item.message" ref="htmlContainer" @click="previewHtmlImage"></div>
											</div>

											<div class="message-image m-top-2" v-else-if="item.message_type == 1" @contextmenu.prevent.stop="handleRightClick(item)">
												<ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

												<div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>
												<img class="product-img pointer" :src="item.message" alt="图片" @click="previewImage(item.message)" />
											</div>

											<div class="message-pubg-product-order m-top-2" v-else-if="item.message_type == 4 || item.message_type == 5 || item.message_type == 9" @contextmenu.prevent.stop="handleRightClick(item)">
												<ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

												<div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>
												<div class="product-number">
													【{{ item.message_type == 4 || item.message_type == 9 ? '商品编号' : '订单编号' }}】 {{ getProductInfo(item).number }}
													<i class="el-icon-copy-document pointer" @click="copyText(getProductInfo(item).number)"></i>
												</div>

												<div class="product-info flex items_center m-top-5 pointer" @click="onClickJumpLink(getProductInfo(item))">
													<img class="product-img m-right-7" :src="getProductInfo(item).pic_image" :alt="getProductInfo(item).name" />
													<div>
														<div class="product-name ellipsis-1">{{ getProductInfo(item).name }}</div>
														<div class="product-tag ellipsis-1 m-top-4 m-bottom-4">{{ getProductInfo(item).arm_tabs }}</div>
														<div class="product-price">
															<span>¥</span>
															{{ getProductInfo(item).price }}
														</div>
													</div>
												</div>
											</div>

											<div class="message-video m-top-2" v-else-if="item.message_type == 6" @contextmenu.prevent.stop="handleRightClick(item)">
												<ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

												<div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>
												<video class="product-video" autoplay muted controls loop :src="item.message"></video>
											</div>

											<div class="message-consult m-top-2" v-else-if="item.message_type == 8">
												<div class="message-consult-title">{{ item.message }}</div>
                                                
                                                <template v-if="(fast_reply?.filter(item => item.pid > 0) || [])?.length > 0">
                                                    <el-collapse class="message-consult-content flex_column m-top-10" style="width: 100%">
                                                        <el-collapse-item :title="reply.title" :name="reply.id" v-for="reply in fast_reply?.filter(item => item.pid > 0) || []" :key="reply.id">
                                                            <div class="kefu-reply-content flex_column m-top-10">
                                                                <div class="kefu-reply-content-item pointer flex items_center jus_spb" v-for="item in reply.second" :key="item.id" @click="onClickFastReply(item)">
                                                                    {{ item.title }}
                                                                    <i class="el-icon-arrow-right"></i>
                                                                </div>
                                                            </div>
                                                        </el-collapse-item>
                                                    </el-collapse>
                                                </template>

                                                <template v-if="(fast_reply?.filter(item => item.pid === 0) || [])?.length > 0">
                                                    <ul class="message-consult-content flex_column m-top-10">
                                                        <li class="message-consult-content-item pointer flex items_center jus_spb" v-for="reply in fast_reply?.filter(item => item.pid === 0) || []" :key="reply.id" @click="onClickFastReply(reply)">
                                                            {{ reply.title }}
                                                            <i class="el-icon-arrow-right"></i>
                                                        </li>
                                                    </ul>
                                                </template>
											</div>

                                            <div class="message-sjz-order m-top-2" v-else-if="item.message_type == 14" @contextmenu.prevent.stop="handleRightClick(item)">
                                                <ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

                                                <div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>

                                                <template>
                                                    <div class="product-order-number flex jus_spb">
                                                        <div>
                                                            【订单编号】 {{ getProductInfo(item).out_trade_no }}
                                                            <i class="el-icon-copy-document pointer" @click="copyText(getProductInfo(item).out_trade_no)"></i>
                                                        </div>
    
                                                        <span>
                                                            【编号】{{ getProductInfo(item).product_number }}
                                                            <i class="el-icon-copy-document pointer" @click="copyText(getProductInfo(item).product_number)"></i>
                                                        </span>
                                                    </div>
    
                                                    <div class="product-timer flex jus_spb m-top-5">
                                                        【起始时间】{{ getProductInfo(item).rent_start_time }} 至 {{ getProductInfo(item).rent_end_time }}
                                                    </div>
                                                    
                                                    <div class="product-info flex  m-top-5 pointer">
                                                        <img class="product-img m-right-7" :src="getProductInfo(item).product_pic_image" :alt="getProductInfo(item).product_name" />
                                                        <div>
                                                            <div class="product-name ellipsis-1">{{ getProductInfo(item).product_name }}</div>
                                                            <div class="product-status m-top-5">订单状态：{{ getProductInfo(item).status_text }}</div>
                                                            <div class="product-money flex m-top-5" style="gap: 5px">
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">押金：</div>
                                                                    <div class="product-money-value">{{ getProductInfo(item).deposit_amount }}元</div>
                                                                </div>
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">实付款：</div>
                                                                    <div class="product-money-value" style="color: rgba(254, 53, 93, 1);">{{ getProductInfo(item).actual_payment || '0.00' }}</div>
                                                                </div>
                                                            </div>
                                                            <div class="order-money flex m-top-5" style="gap: 5px">
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">租期：</div>
                                                                    <div class="product-money-value">{{ getProductInfo(item).rental_days }}天</div>
                                                                </div>
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">预付租金：</div>
                                                                    <div class="product-money-value">{{ getProductInfo(item).amount || '0.00' }}元</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
											</div>
                                            
                                            <div class="message-sjz-product m-top-2" v-else-if="item.message_type == 13" @contextmenu.prevent.stop="handleRightClick(item)">
                                                <ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

                                                <div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>

                                                <template>
                                                    <div class="product-product-number flex">
                                                        【编号】{{ getProductInfo(item).sn }}
                                                        <i class="el-icon-copy-document pointer m-left-5" @click="copyText(getProductInfo(item).sn)"></i>
                                                    </div>
                                                    
                                                    <div class="product-info flex  m-top-5 pointer">
                                                        <img class="product-img m-right-7" :src="handleImage(getProductInfo(item).product_images)" :alt="getProductInfo(item).product_title" />
                                                        <div>
                                                            <div class="product-name ellipsis-1">{{ getProductInfo(item).product_title }}</div>
                                                            <div class="product-timer flex jus_spb m-top-5">
                                                                【创建时间】{{ getProductInfo(item).create_time }}
                                                            </div>
                                                            <div class="product-money flex m-top-5" style="gap: 5px">
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">租金：</div>
                                                                    <div class="product-money-value">{{ getProductInfo(item).rental_price || '-' }}元</div>
                                                                </div>
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">手续费：</div>
                                                                    <div class="product-money-value">{{ getProductInfo(item).transaction_fee || '-' }}元</div>
                                                                </div>
                                                            </div>
                                                            <div class="product-money flex m-top-5" style="gap: 5px">
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">押金：</div>
                                                                    <div class="product-money-value">{{ getProductInfo(item).deposit || '-' }}元</div>
                                                                </div>
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-money-lable">实收租金：</div>
                                                                    <div class="product-money-value">{{ getProductInfo(item).seller_income || '-' }}元</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
											</div>

                                            <div class="message-sjz-crash m-top-2" v-else-if="item.message_type == 15" @contextmenu.prevent.stop="handleRightClick(item)">
                                                <ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

                                                <div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>

                                                <template>
                                                    <div class="message-sjz-crash-number flex jus_spb">
                                                        <div>
                                                            【订单编号】 {{ getProductInfo(item).order_no }}
                                                            <i class="el-icon-copy-document pointer" @click="copyText(getProductInfo(item).order_no)"></i>
                                                        </div>
    
                                                        <span>
                                                            【订单状态】{{ getProductInfo(item).status_text || '-' }}
                                                        </span>
                                                    </div>
                                                    
                                                    <div class="message-sjz-crash-money flex m-top-5">
                                                        <div class="message-sjz-crash-money-lable">预计到账：</div>
                                                        <div class="message-sjz-crash-money-value">
                                                            <span>¥</span>{{ getProductInfo(item).amount || '-' }}元
                                                        </div>
                                                    </div>
    
                                                    <div class="message-sjz-crash-info m-top-5 pointer">
                                                        <div class="message-sjz-crash-info-name ellipsis-1">{{ getProductInfo(item).goods_text }}</div>
                                                        <div class="message-sjz-crash-info-row flex m-top-5" style="gap: 5px">
                                                            <div class="flex" style="flex: 1;">
                                                                <div class="message-sjz-crash-info-row-lable">订单类型：</div>
                                                                <div class="message-sjz-crash-info-row-value">{{ getProductInfo(item).trade_type_text || '-' }}</div>
                                                            </div>
                                                            <div class="flex" style="flex: 1;">
                                                                <div class="message-sjz-crash-info-row-lable">出货ID：</div>
                                                                <div class="message-sjz-crash-info-row-value">{{ getProductInfo(item).sn || '-' }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="message-sjz-crash-info-row flex m-top-5" style="gap: 5px">
                                                            <div class="flex" style="flex: 1;">
                                                                <div class="message-sjz-crash-info-row-lable">游戏ID：</div>
                                                                <div class="message-sjz-crash-info-row-value">{{ getProductInfo(item).account_number || '-' }}</div>
                                                            </div>
                                                            <div class="flex" style="flex: 1;">
                                                                <div class="message-sjz-crash-info-row-lable">进度：</div>
                                                                <div class="message-sjz-crash-info-row-value">{{ getProductInfo(item).status_text || '-' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
											</div>

                                            <div class="message-sjz-publish-lease m-top-2" v-else-if="item.message_type == 16" @contextmenu.prevent.stop="handleRightClick(item)">
                                                <ul class="operation-list" v-if="item.isrevoke">
													<li class="operation-list-item pointer" @click="onClickRevokeMessage(item)">撤回</li>
												</ul>

                                                <div class="message-status">{{ item.status == 0 ? '未读' : '已读' }}</div>

                                                <template>
                                                    <div class="message-sjz-publish-lease-row flex items_center jus_spb">
                                                        <div class="message-sjz-publish-lease-row-number flex items_center">
                                                            三角洲-<span>哈夫币出租</span>&nbsp;&nbsp;
                                                            {{ getProductInfo(item).sn || '-' }} &nbsp;<i class="el-icon-copy-document pointer" @click="copyText(getProductInfo(item).sn)"></i>
                                                        </div>
                                                        <div class="message-sjz-publish-lease-row-status">{{ getProductInfo(item).status_text || '-' }}</div>
                                                    </div>
    
                                                    <div class="message-sjz-publish-lease-details flex items_start m-top-10">
                                                        <img class="message-sjz-publish-lease-details-img m-right-7" :src="handleImageUrl(getProductInfo(item).product_images)" :alt="getProductInfo(item).product_title" />
    
                                                        <div class="message-sjz-publish-lease-details-info">
                                                            <div class="message-sjz-publish-lease-details-info-name">{{ getProductInfo(item).hafu_coins || '-' }}M哈夫币，比例1:{{ getProductInfo(item).rental_ratio || '-' }}</div>
                                                            <div class="message-sjz-publish-lease-details-info-tag m-top-10 ellipsis-4">
                                                                {{ getProductInfo(item).product_title || '-' }}
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                    <div class="message-sjz-publish-lease-status m-top-10">{{ getProductInfo(item).status_text || '-' }}</div>
                                                    
                                                    <div class="message-sjz-publish-lease-price-row m-top-10 flex items_center jus_spb">
                                                        <div class="flex items_center jus_spb" style="flex: 1">
                                                            <div class="message-sjz-publish-lease-price-row-lable">租金：</div>
                                                            <div class="message-sjz-publish-lease-price-row-value"><span>￥</span>{{ getProductInfo(item).rental_price || '-' }}</div>
                                                        </div>
                                                        <el-divider direction="vertical"></el-divider>
                                                        <div class="flex items_center jus_spb" style="flex: 1">
                                                            <div class="message-sjz-publish-lease-price-row-lable">押金：</div>
                                                            <div class="message-sjz-publish-lease-price-row-value"><span>￥</span>{{ getProductInfo(item).deposit || '-' }}</div>
                                                        </div>
                                                    </div>

                                                    <div class="message-sjz-publish-lease-price-row m-top-10 flex items_center jus_spb">
                                                        <div class="flex items_center jus_spb" style="flex: 1">
                                                            <div class="message-sjz-publish-lease-price-row-lable">到手价：</div>
                                                            <div class="message-sjz-publish-lease-price-row-value"><span>￥</span>{{ getProductInfo(item).seller_income || '-' }}</div>
                                                        </div>
                                                        <el-divider direction="vertical"></el-divider>
                                                        <div class="flex items_center jus_spb" style="flex: 1">
                                                            <div class="message-sjz-publish-lease-price-row-lable">手续费：</div>
                                                            <div class="message-sjz-publish-lease-price-row-value"><span>￥</span>{{ getProductInfo(item).transaction_fee || '-' }}</div>
                                                        </div>
                                                    </div>
                                                </template>
											</div>
										</div>

										<div class="avatar-container m-left-14" v-if="item.sender == 'me'">
											<img :src="item.avatar" :alt="item.name" />
										</div>
									</div>
								</div>
							</template>
						</template>
					</div>

					<div class="input-container" v-if="!isBlack">
						<ul class="tool-box flex">
                            <!-- v-if="[1, 2].includes(platform_options)" -->
							<template >
								<el-popover placement="top" width="460" trigger="click" popper-class="consult-product-popover" :disabled="!encryptUserInfo" :append-to-body="false">
									<template>
										<ul class="consult-product-popover-tabs kefu-tabs flex">
											<li class="consult-product-popover-tabs-item kefu-tabs-item p-bottom-5 pointer" :class="{ active: item.id == consultProductTabActive }" v-for="item in consultProductTabs" :key="item.id" @click="onClickConsultProduct(item.id)">
												<i :class="['iconfont', item.icon]"></i>
												{{ item.name }}
												<div class="kefu-tabs-item-line"></div>
											</li>
										</ul>
										<div class="consult-product-popover-container" v-loading="consultTabActiveParams.loading">
											<ul class="consult-product-popover-container-list">
												<li class="consult-product-popover-container-list-item flex pointer" v-for="item in consultTabActiveList" :key="item.id" @click="onClickJumpLink(item)">
													<img class="consult-product-popover-container-list-item-img m-right-6" :src="item.pic_image" :alt="item.name" />
													<div class="consult-product-popover-container-list-item-info">
														<div class="consult-product-popover-container-list-item-info-name ellipsis-2">{{ item.name }}</div>
														<div class="consult-product-popover-container-list-item-info-number m-top-6 m-bottom-6">【商品编号】{{ item.number }}</div>
														<div class="flex jus_spb">
															<div class="consult-product-popover-container-list-item-info-price">
																<span>¥</span>
																{{ item.price }}
															</div>
															<el-button size="mini" type="primary" @click.stop="sendProduct(item, 4, 1)">发送</el-button>
														</div>
													</div>
												</li>
												<li class="consult-product-popover-container-empty-container flex items_center jus_center" v-if="consultTabActiveList.length == 0">
													<i class="iconfont icon-zanwushuju"></i>
												</li>
											</ul>
										</div>
										<div class="order-popover-pagination p-top-10 flex jus_center">
											<el-pagination
												small
												:pager-count="5"
												:disabled="consultTabActiveParams.loading"
												background
												layout="prev, pager, next, ->, total"
												:current-page="consultTabActiveParams.page"
												:page-size="consultTabActiveParams.page_size"
												:total="consultTabActiveParams.total"
												@current-change="handleCurrentChange($event, consultProductTabActive == 1 ? 'browse' : 'collect')"></el-pagination>
										</div>
									</template>
	
									<li slot="reference" class="tool-item flex pointer" @click="onClickToolItem(1)">
										<i class="iconfont icon-shangpin"></i>
										咨询商品
									</li>
								</el-popover>
	
								<el-popover placement="top" width="480" trigger="click" popper-class="order-popover" :disabled="!encryptUserInfo" :append-to-body="false">
									<template>
										<div class="prompt">您想咨询哪一类订单呢？可以直接点击下方选项：</div>
										<ul class="order-popover-tabs kefu-tabs flex">
											<li class="order-popover-tabs-item kefu-tabs-item p-bottom-5 pointer" :class="{ active: item.id == orderTabActive }" v-for="item in orderTabs" :key="item.id" @click="onClickOrderTabs(item.id)">
												<i :class="['iconfont', item.icon]"></i>
												{{ item.name }}
												<div class="kefu-tabs-item-line"></div>
											</li>
										</ul>
                                        <div class="order-popover-container" v-loading="orderTabActiveParams.loading">
                                            <ul :class="getOrderPopoverClass(orderTabActive)">
                                                <li :class="getOrderPopoverItemClass(orderTabActive)" class="pointer" v-for="item in orderTabActiveList" :key="item.id">
                                                    <!-- PUBG二手号\卡密订单 -->
                                                    <template v-if="[1, 2].includes(orderTabActive)">
                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-no', 'm-bottom-5', 'flex', 'jus_spb']">【订单编号】{{ item.out_trade_no || '-' }}</div>
                                                        <div class="flex">
                                                            <img :class="[getOrderPopoverItemClass(orderTabActive) + '-img', 'm-right-6']" :src="handleImage(item.product_pic_image)" :alt="item.product_name" />
                                                            <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info']">
                                                                <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-name', 'ellipsis-2']" :title="item.product_name">{{ item.product_name || '-' }}</div>
                                                                <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-number', 'm-top-6', 'm-bottom-6']">
                                                                    【商品编号】{{ item.product_number || '-' }}
                                                                    <template v-if="orderTabActive == 2">
                                                                        {{ item.pack_name || '-' }}
                                                                    </template>
                                                                </div>
                                                                <div class="flex jus_spb">
                                                                    <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-price']">
                                                                        <span>¥</span>
                                                                        {{ item.amount || '-' }}
                                                                    </div>
                                                                    <el-button size="mini" type="primary" @click="sendProduct(item, 5, 2)">发送</el-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <!-- 三角洲租赁订单 -->
                                                    <template v-else-if="[3].includes(orderTabActive)">
                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-no', 'm-bottom-5', 'p-right-10', 'flex','jus_spb']">
                                                            【订单编号】{{ item.out_trade_no || '-' }}

                                                            <span>【编号】{{ item.product_number || '-' }}</span>
                                                        </div>
                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-time', 'm-bottom-5']">【起始时间】{{ item.rent_start_time || '-' }} 至 {{ item.rent_end_time || '-' }}</div>
                                                        <div class="flex">
                                                            <img :class="[getOrderPopoverItemClass(orderTabActive) + '-img', 'm-right-6']" :src="handleImage(item.product_pic_image)" :alt="item.product_name" />
                                                            <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info']">
                                                                <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-name', 'ellipsis-1', 'm-bottom-5']" :title="item.product_name">{{ item.product_name || '-' }}</div>
                                                                <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-status', 'm-bottom-5']">订单状态：{{ item.status_text || '-' }}</div>
                                                                <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail', 'flex', 'm-bottom-5']" style="gap: 5px">
                                                                    <div class="flex" style="flex: 1;">
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-lable']">押金：</div>
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-value']">{{ item.deposit_amount || '-' }}元</div>
                                                                    </div>
                                                                    <div class="flex" style="flex: 1;">
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-lable']">实付款：</div>
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-value']">{{ item.actual_payment || '0.00' }}</div>
                                                                    </div>
                                                                </div>
                                                                <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail', 'flex', 'm-bottom-5']" style="gap: 5px">
                                                                    <div class="flex" style="flex: 1;">
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-lable']">租期：</div>
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-value']">{{ item.rental_days || '-' }}天</div>
                                                                    </div>
                                                                    <div class="flex" style="flex: 1;">
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-lable']">预付租金：</div>
                                                                        <div :class="[getOrderPopoverItemClass(orderTabActive) + '-info-detail-value']">{{ item.amount || '-' }}元</div>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="flex jus_end">
                                                                    <el-button size="mini" type="primary" @click="sendProduct(item, 14, 5)">发送</el-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <!-- 三角洲撞车订单 -->
                                                    <template v-else-if="[4].includes(orderTabActive)">
                                                        <div class="order-popover-container-sjz-crash-list-item-no m-bottom-5 p-right-10 flex jus_spb">
                                                            【订单编号】{{ item.order_no || '-' }}

                                                            <span>【订单状态】{{ item.status_text || '-' }}</span>
                                                        </div>
                                                        <div class="order-popover-container-sjz-crash-list-item-name ellipsis-1 m-bottom-5" :title="'三角洲撞车订单'">{{ item.goods_text || '-' }}</div>
                                                        <div class="order-popover-container-sjz-crash-list-item-price flex items_center jus_spb m-bottom-5">
                                                            <div class="order-popover-container-sjz-crash-list-item-price-lable">预计到账</div>
                                                            <div class="order-popover-container-sjz-crash-list-item-price-value"><span>¥</span> {{ item.amount || '-' }}</div>
                                                        </div>
                                                        <div class="order-popover-container-sjz-crash-list-item-row flex m-bottom-5" style="gap: 5px; background-color: #f4f6fa; padding: 5px; border-radius: 5px;">
                                                            <div class="flex" style="flex: 1;">
                                                                <div class="order-popover-container-sjz-crash-list-item-row-lable">订单类型：</div>
                                                                <div class="order-popover-container-sjz-crash-list-item-row-value">{{ item.trade_type_text || '-' }}</div>
                                                            </div>
                                                            <div class="order-popover-container-sjz-crash-list-item-row flex" style="flex: 1;">
                                                                <div class="order-popover-container-sjz-crash-list-item-row-lable">出货ID：</div>
                                                                <div class="order-popover-container-sjz-crash-list-item-row-value">{{ item.sn || '-' }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="order-popover-container-sjz-crash-list-item-row flex m-bottom-5" style="gap: 5px; background-color: #f4f6fa; padding: 5px; border-radius: 5px;">
                                                            <div class="flex" style="flex: 1;">
                                                                <div class="order-popover-container-sjz-crash-list-item-row-lable">游戏ID：</div>
                                                                <div class="order-popover-container-sjz-crash-list-item-row-value">{{ item.account_number || '-' }}</div>
                                                            </div>
                                                            <div class="flex" style="flex: 1;">
                                                                <div class="order-popover-container-sjz-crash-list-item-row-lable">进度：</div>
                                                                <div class="order-popover-container-sjz-crash-list-item-row-value">{{ item.trade_type_text || '-' }}</div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="flex jus_end">
                                                            <el-button size="mini" type="primary" @click="sendProduct(item, 15, 7)">发送</el-button>
                                                        </div>
                                                    </template>
                                                </li>

                                                <li class="order-popover-container-empty-container flex items_center jus_center" v-if="orderTabActiveList.length == 0">
													<i class="iconfont icon-zanwushuju"></i>
												</li>
                                            </ul>
                                        </div>
										<div class="order-popover-pagination p-top-10 flex jus_center">
											<el-pagination
												small
												:pager-count="5"
												:disabled="orderTabActiveParams.loading"
												background
												layout="prev, pager, next, ->, total"
												:current-page="orderTabActiveParams.page"
												:page-size="orderTabActiveParams.page_size"
												:total="orderTabActiveParams.total"
												@current-change="handleCurrentChange($event, orderTabActive == 1 ? 'secondHand' : orderTabActive == 2 ? 'carmi' : orderTabActive == 3 ? 'delta' : 'crash')"></el-pagination>
										</div>
									</template>
	
									<li slot="reference" class="tool-item flex pointer" @click="onClickToolItem(2)">
										<i class="iconfont icon-kefu-dingdan"></i>
										我的订单
									</li>
								</el-popover>
	
								<el-popover placement="top" width="500" trigger="click" popper-class="product-popover" :disabled="!encryptUserInfo" :append-to-body="false">
									<template>
										<div class="prompt">请选择您要咨询的商品？</div>
                                        <ul class="product-popover-tabs kefu-tabs flex">
											<li class="product-popover-tabs-item kefu-tabs-item p-bottom-5 pointer" :class="{ active: item.id == myProductTabActive }" v-for="item in myProductTabs" :key="item.id" @click="onClickMyProductTabs(item.id)">
												<i :class="['iconfont', item.icon]"></i>
												{{ item.name }}
												<div class="kefu-tabs-item-line"></div>
											</li>
										</ul>
										<div class="product-popover-container" v-loading="myProductTabActiveParams.loading">
											<ul class="product-popover-container-list">
												<li class="product-popover-container-list-item flex pointer" v-for="item in myProductTabActiveList" :key="item.id" @click="onClickJumpLink(item)">
                                                    <!-- 我的商品 - 寄售商品 -->
                                                    <template v-if="[1].includes(myProductTabActive)">
                                                        <img class="product-popover-container-list-item-img m-right-6" :src="item.pic_image" :alt="item.name" />
                                                        <div class="product-popover-container-list-item-info">
                                                            <div class="product-popover-container-list-item-info-name ellipsis-2" :title="item.name">{{ item.name || '-' }}</div>
                                                            <div class="product-popover-container-list-item-info-number">【商品编号】{{ item.number || '-' }}</div>
                                                            <div class="flex jus_spb">
                                                                <div class="product-popover-container-list-item-info-price">
                                                                    <span>¥</span>
                                                                    {{ item.price }}
                                                                </div>
                                                                <el-button size="mini" type="primary" @click.stop="sendProduct(item, 4, 3)">发送</el-button>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <!-- 我的商品 - 三角洲租赁商品 -->
                                                    <template v-else>
                                                        <img class="product-popover-container-list-item-sjz-img m-right-6" :src="handleImage(item.product_images)" :alt="item.product_title" />

                                                        <div class="product-popover-container-list-item-sjz-info">
                                                            <div class="product-popover-container-list-item-sjz-info-title ellipsis-1" :title="item.product_title">{{ item.product_title || '-' }}</div>
                                                            <div class="product-popover-container-list-item-sjz-info-number m-top-5">【商品编号】{{ item.sn || '-' }}</div>
                                                            <div class="product-popover-container-list-item-sjz-info-time m-top-5">创建时间：{{ item.create_time || '-' }}</div>
                                                            <div class="product-popover-container-list-item-sjz-info-row flex m-top-5" style="gap: 5px">
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-popover-container-list-item-sjz-info-row-lable">租金：</div>
                                                                    <div class="product-popover-container-list-item-sjz-info-row-value">{{ item.rental_price || '-' }}元</div>
                                                                </div>
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-popover-container-list-item-sjz-info-row-lable">手续费：</div>
                                                                    <div class="product-popover-container-list-item-sjz-info-row-value">{{ item.transaction_fee || '-' }}元</div>
                                                                </div>
                                                            </div>
                                                            <div class="product-popover-container-list-item-sjz-info-row flex m-top-5" style="gap: 5px">
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-popover-container-list-item-sjz-info-row-lable">押金：</div>
                                                                    <div class="product-popover-container-list-item-sjz-info-row-value">{{ item.deposit || '-' }}元</div>
                                                                </div>
                                                                <div class="flex" style="flex: 1;">
                                                                    <div class="product-popover-container-list-item-sjz-info-row-lable">实收租金：</div>
                                                                    <div class="product-popover-container-list-item-sjz-info-row-value">{{ item.seller_income || '-' }}元</div>
                                                                </div>
                                                            </div>
                                                            <div class="flex jus_end m-top-5">
                                                                <el-button size="mini" type="primary" @click.stop="sendProduct(item, 13, 6)">发送</el-button>
                                                            </div>
                                                        </div>
                                                    </template>
												</li>
												<li class="product-popover-container-empty-container flex items_center jus_center" v-if="myProductTabActiveList.length == 0">
													<i class="iconfont icon-zanwushuju"></i>
												</li>
											</ul>
										</div>
										<div class="product-popover-pagination p-top-10 flex jus_center">
											<el-pagination
												small
												:pager-count="5"
												:disabled="myProductTabActiveParams.loading"
												background
												layout="prev, pager, next, ->, total"
												:current-page="myProductTabActiveParams.page"
												:page-size="myProductTabActiveParams.page_size"
												:total="myProductTabActiveParams.total"
												@current-change="handleCurrentChange($event, myProductTabActive == 1 ? 'product' : 'sjzRental')"></el-pagination>
										</div>
									</template>
	
									<li slot="reference" class="tool-item flex pointer" @click="onClickToolItem(3)">
										<i class="iconfont icon-kefu-shangpin-copy"></i>
										我的商品
									</li>
								</el-popover>
							</template>

							<li class="tool-item urge flex pointer" v-if="activeSession.session_type == 0" @click="urgeReply">
								<i class="iconfont icon-naozhong_o"></i>
								催促回复
							</li>
						</ul>

						<div class="tool-bar flex items_center">
							<el-popover placement="top" width="385" trigger="hover" popper-class="emoji-popover" :append-to-body="false">
								<template>
									<ul class="emoji-container flex flex_wrap">
										<li class="emoji-category pointer" v-for="(category, index) in emojiCategories" :key="index" @mousedown.prevent @click="selectCategory(category)">{{ category }}</li>
									</ul>
								</template>

								<i slot="reference" class="iconfont icon-xiaolian pointer" title="图标"></i>
							</el-popover>
							<i class="iconfont icon-tupian pointer" title="图片" @click="uploadImage"></i>
							<i class="iconfont icon-video pointer" title="视频" @click="uploadVideo"></i>
						</div>

						<div class="textarea-container">
							<div id="message-editor" class="custom-editor" contenteditable="true" @paste="handlePaste" @input="handleInput" @keydown.enter.exact.prevent="handleEnterKey" @keydown.shift.enter.prevent="insertNewline" placeholder="请输入..."></div>
						</div>

						<div class="btn-container flex items_center jus_end p-top-8">
							<i class="m-right-20">按Enter键发送，按Shift+Enter键换行</i>
							<el-button class="send-btn" type="primary" @click="sendMessage">发送</el-button>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
// 导入WebSocket服务
import { createWebSocket } from '@/utils/websocket.js';
// 导入初始化接口
import { initialize } from '@/api/socket-index.js';
// 全局 mixin
import globalMixin from '@/mixins/index-socket-chat.js';
// 导入配置信息
import configInfo from '@/utils/config.js';
// 导入工具函数
import { validateMediaFile, uploadFileToAliyunOSS } from "@/utils/oss-upload"
import { copy } from '@/utils/publicFn.js';
import { playNotificationSound } from '@/utils/audio';

// 工具栏配置（模块级常量，避免每次调用重新创建）
const TOOL_ITEM_CONFIG = {
	// type 1: 咨询商品
	1: {
		1: { control: 'Message', action: 'consultGoods', pageKey: 'browseParams' },       // 我的浏览商品
		2: { control: 'Message', action: 'collectList', pageKey: 'collectParams' }       // 我的收藏商品
	},
	// type 2: 我的订单
	2: {
		1: { control: 'Message', action: 'orderList', pageKey: 'secondHandParams' },      // 二手号订单
		2: { control: 'Message', action: 'carmiOrderList', pageKey: 'carmiParams' },     // 卡密商品订单
		3: { control: 'OrderManager', action: 'rentalOrderList', pageKey: 'deltaRentalParams' }, // 三角洲租赁订单
		4: { control: 'OrderManager', action: 'collisionOrderList', pageKey: 'deltaCrashParams' } // 三角洲撞车订单
	},
	// type 3: 我的商品
	3: {
		1: { control: 'Message', action: 'userFlowProduct', pageKey: 'productParams' },  // 我的寄售商品
		2: { control: 'SjzManager', action: 'userSjzProduct', pageKey: 'sjzRentalParams' } // 我的三角洲商品
	}
};

export default {
	// 组件名称
	name: 'CustomerService',

	// 接收的属性
	props: {
		// 来源域名
		referrer: {
			type: String,
			default: ''
		},

		// 用户登陆信息
		encryptUserInfo: {
			type: String,
			default: 'yDeSVPWHwWJ8SDGdA%2FJEkBPr1R%2BzZ5si%2FraMEg0qjiZGmozoJOT3EYP6KS1J0mfMZ8wx1%2FGYE14uzSr9CmnzS2PusLcOOXeFPWcdqoCgPlRO0UCupoHGd8bPHLa%2FYtXw%2Bz1X0uBcb7PLGzCj1dKl8BM4FIRjZ0JEogX9pyWhk%2Bn5%2FXpozBRWjDmIR9nBVkSCcTNNTf7CoACDtdSo8EM2YX%2FmbB3Ni%2BimJTNKW1UhWy8V4CbuV15UrEOUM5SAKxd9n%2F5IcBhXW7zFtAuk%2BlPatfSnGbogKJs%2Fl%2BmYOV5a0DZC4Xw0KDkgXruak2BjIO4KZxKbwF6fl5OwxiC8QlFwHgdRsb7JoIPOfflyLT2534VhQPVsFB3SbWPFuAAvL3WmnV0bT8XOP2NzaOo2qURTQTV8g%2BjjbvA2NngfuYYINNorS4nCDXCjhy3oisP6tlAdmP5tRSM1w4i1t9iGJZveSk2hFvsz%2Fq63zBHqLPmwA%2BsDcThI3hza20nuUpBahRRl%2BbVLlbCZuM%2FjN0gCKPAPwKpx5W4ONJD6XCdnt8KvVRvSKXroayfKEcTJKnaY2O2CCd4pXpUp5%2Brcn0q%2BLw3oM8d6t7mL3UQj4xf45joe%2BkQ%2BYdZcytOw80iJv91kzJPUO3kTOuduAt0lxswdbBKWyoPyp9e0A4WLxWq%2FyOuE3rZhywLUDKiUa2Q%2FG3jUaZq95WoFG17rrAnWIa%2Fmfi8lYmVTJugoHVaSAVcqX%2FKUrlsibMNXs7ctEH6wzCxd9EBt769ty6iZSehVyHn0BNuoD1Q%2BYYw18cUz00AVJA2GyOrMKNCaCfxHJw0wGJ6muP3ZqUUldsdNt5Ju%2FQ3%2B%2B9KHSaQTP17iz52eeXWoG%2F4Fv4wq4s33JXQ4nNUK%2FfR5NstZSox9BHojr7IrDpnqFCS%2FQZdP8jSmY8QInG6aTfbPNQmfmD3M4Y%2F1y7fWMDytnMoL3dBesJJK7jIZshSQzQPvtZpPZaOzA649%2FlPG74OhvqqUjLaz874RTfCr1vOehBUGpErtrsVrcsd9UCobRYF%2FLTw2uSbT7baRy4LlL7deJlpumok%2FNA9e5aDB2XznJXz0alF5%2Bbgq%2BNIb%2Fe4G2vrOHwo%2Bm5QvaMRr7AylVj%2BvBe7vbkvr6McOULZ%2FIm6jfsQcS%2FYCxoYHqq%2FugbRDqIynvPy9qgxJNSVEej8x6FpoZSbtaRikEqJqGAR9Vp8yt5%2FG6qAA44TNBL8ekWgHM7QgZpf2%2BdHtBLJezeHkOYTbjvQ1EpgdJhY8pF0Af3f7H2szuO70aqi7NxvyvIiK4P%2FWn4DRaF05WPqC4QoPszUEhIWEla9Zp7VaEUJ8PnM0OGBIGxNX3gD99tCkipVdjwvKqWiaByJ4B7cASTaKKgtRSscsNhT0hoLDZVd0WcJIPLEpQnbXqVNGpFRffifl1uT36plRY0zZnxoIJ1%2BvpdpY4g1AzhJnS1Nqi3ylCGV9NOeuG3wgvyWc4UW5HiRx6HM5Gs9UuazJWCdFhdAkaMKyJ1XomPuQTeOSrdkdOC9QojAKb9UIXOGIU3kUITC2WgtvzHxPQn7eMtLYHe75fqeasAJc0oiHIHJ6%2F7MDpnjOkrFu4Y8ZMY6ozAylKQbnjv565ymQeMDQYPAXJc4lPJethSq3fEDe%2BVgabP%2Frx8vaqlXL6kQyQ7c4kuNk5dzOfZ%2Fo00e4JyrG%2BixmCu84B8TIUpdYkADbLjKtJ9PDcG7o1BcanoWMdeVODATZbIaC9xjrGQQsZMbaLKQrC6rWmBC2NBo%3D'
		},

		// 来源
		source: {
			type: String,
			default: ''
		}
	},

	// 数据
	data() {
		return {
			// ── 拖拽相关数据 ──────────────────────────────────────────────────────────
			isDragging: false, // 是否正在拖拽
			startX: 0, // 拖拽开始时的鼠标X坐标
			startY: 0, // 拖拽开始时的鼠标Y坐标
			startLeft: 0, // 拖拽开始时的容器左位置
			startTop: 0, // 拖拽开始时的容器上位置
			buttonPosition: { x: 0, y: 0 }, // 按钮位置
			isChatVisible: false, // 聊天窗口是否可见
			hasMoved: false, // 标记是否有移动
			chatOriginStyle: {}, // 聊天窗口缩放动画的 transform-origin
			kefuButtonPressed: false, // 浮标按下状态
			kefuButtonActive: false, // 浮标点击回弹动画触发状态
			kefuButtonVisible: true, // 浮标显隐（关闭动画期间隐藏，避免出现在居中位置）

			// ── 聊天滚动相关 ──────────────────────────────────────────────────────────
			isUserViewingChat: false, // 用户是否正在查看聊天记录
			lastScrollTime: 0, // 最后一次滚动时间
			scrollTimer: null, // 滚动定时器

			// ── 游客token ──────────────────────────────────────────────────────────
			tourists_token: '',

			// ── 会话分类 ──────────────────────────────────────────────────────────
			tabs: [
				{ id: 'all', name: '全部' },
				{ id: 'private', name: '私聊' },
				{ id: 'group', name: '群聊' }
			],
			// 当前选中的会话标签
			activeTab: 'all',

			// ── 输入框 ──────────────────────────────────────────────────────────
			inputValue: '', // 搜索输入框内容
			editorHtmlContent: '', // 获取HTML内容（包含图片）
			editorTextContent: '', // 获取文本内容（不包含HTML标签）

            _defaultMessageHandler: null, // 默认消息处理器引用

            time: null, // 时间
            lastUrgeTime: 0, // 上次发送"催一催"的时间戳
		};
	},

	computed: {
		// 是否显示客服窗口
		showKefuButton: () => globalMixin.state.showKefuButton,
		// 提示内容
		tipContent: () => globalMixin.state.tipContent,
		// 是否显示提示
		tipVisible: () => globalMixin.state.tipVisible,

		// 当前socket实例
		indexSocket: () => globalMixin.state.indexSocket,
		// socket 连接状态
		wsConnected: () => globalMixin.state.wsConnected,
        // 是否拉黑
        isBlack: () => globalMixin.state.isBlack,
		// 聊天区域实例
		chatMessagesRef: () => globalMixin.state.chatMessagesRef,
		// 用户信息
		user_info: () => globalMixin.state.user_info,
		// 快捷回复
		fast_reply: () => globalMixin.state.fast_reply,
		// 客服端平台选项
		platform_options: () => globalMixin.state.platform_options,
		// 会话列表
		session_list: () => globalMixin.state.session_list,
		// 当前会话
		activeSession: () => globalMixin.state.activeSession,
		// 消息列表
		session_messages: () => globalMixin.state.session_messages,
		// 分页
		pageParams: () => globalMixin.state.pageParams,
		// 加载状态
		loadingMessages: () => globalMixin.state.loadingMessages,
		// 用户发送消息记录数量 + 和客服发送消息记录数量
		unexpected_records: () => globalMixin.state.unexpected_records,
		// 表情列表
		emojiCategories: () => globalMixin.state.emojiCategories,

		// 自动回复商品展示状态
		automaticallyProductShow: () => globalMixin.state.automaticallyProductShow,
		// 自动回复商品信息
		automaticallyProductInfo: () => globalMixin.state.automaticallyProductInfo,

		// 咨询商品 tabs 列表
		consultProductTabs: () => globalMixin.state.consultProductTabs,
		// 咨询商品 tabs 当前选中项
		consultProductTabActive: () => globalMixin.state.consultProductTabActive,
		// 我的咨询 - 当前选中项 分页参数
		consultTabActiveParams() {
			if (globalMixin.state.consultProductTabActive == 1) {
				return globalMixin.state.browseParams;
			} else if (globalMixin.state.consultProductTabActive == 2) {
				return globalMixin.state.collectParams;
			}
			return {};
		},
		// 我的咨询 - 当前选中项 列表数据
		consultTabActiveList() {
			if (globalMixin.state.consultProductTabActive == 1) {
				return globalMixin.state.browse_list;
			} else if (globalMixin.state.consultProductTabActive == 2) {
				return globalMixin.state.collect_list;
			}
			return [];
		},

		// 我的订单 tabs 列表
		orderTabs: () => globalMixin.state.orderTabs,
		// 我的订单 tabs 当前选中项
		orderTabActive: () => globalMixin.state.orderTabActive,
		// 我的订单 - 当前选中项 分页参数
		orderTabActiveParams() {
			if (globalMixin.state.orderTabActive == 1) {
				return globalMixin.state.secondHandParams;
			} else if (globalMixin.state.orderTabActive == 2) {
				return globalMixin.state.carmiParams;
			} else if (globalMixin.state.orderTabActive == 3) {
				return globalMixin.state.deltaRentalParams;
			} else if (globalMixin.state.orderTabActive == 4) {
				return globalMixin.state.deltaCrashParams;
			}
			return {};
		},
		// 我的订单 - 当前选中项 列表数据
		orderTabActiveList() {
			if (globalMixin.state.orderTabActive == 1) {
				return globalMixin.state.secondHandList;
			} else if (globalMixin.state.orderTabActive == 2) {
				return globalMixin.state.carmiList;
			} else if (globalMixin.state.orderTabActive == 3) {
				return globalMixin.state.deltaRentalList;
			} else if (globalMixin.state.orderTabActive == 4) {
				return globalMixin.state.deltaCrashList;
			}
			return [];
		},

        // 我的商品 tabs 列表
		myProductTabs: () => globalMixin.state.myProductTabs,
		// 我的商品 tabs 当前选中项
		myProductTabActive: () => globalMixin.state.myProductTabActive,
        // 我的商品 - 当前选中项 分页参数
		myProductTabActiveParams() {
			if (globalMixin.state.myProductTabActive == 1) {
				return globalMixin.state.productParams;
			} else if (globalMixin.state.myProductTabActive == 2) {
				return globalMixin.state.sjzRentalParams;
			}
			return {};
		},
		// 我的商品 - 当前选中项 列表数据
		myProductTabActiveList() {
			if (globalMixin.state.myProductTabActive == 1) {
				return globalMixin.state.productList;
			} else if (globalMixin.state.myProductTabActive == 2) {
				return globalMixin.state.sjzRentalList;
			}
			return [];
		},
		// 未读消息数量
		unreadMessagesCount: () => globalMixin.state.unreadMessagesCount,
	},

	// 监听属性变化
	watch: {
		// 监听聊天窗口显示状态
		showKefuButton(newVal) {
			if (newVal) {
				// 显示聊天窗口时，获取按钮位置并居中显示
				const buttonPos = this.getButtonPosition();
				this.showChat(buttonPos);

                // 发送请求
                this.indexSocket.send({
                    c: 'Message',
                    a: 'sessionListInitialize',
                    data: {
                        fixed_csr: 0,
                        pageUrl: window.location.href,
                        csr: 0
                    }
                });

                let order_no = localStorage.getItem('order_no') || '';
                if (order_no) {
                    this.indexSocket.send({
                        c: 'SessionManager',
                        a: 'createOrderGroup',
                        data: {
                            order_no: order_no,
                            is_zz: 1,
                        }
                    });
                }

				// 显示聊天窗口时，滚动到最底部
				this.$nextTick(() => {
					const chatMessages = this.chatMessagesRef;
					if (chatMessages) {
						chatMessages.scrollTop = chatMessages.scrollHeight;
					}
				});
			} else {
				// 隐藏聊天窗口
				this.hideChat();
			}
		}
	},

	// 组件创建时执行
	created() {
		// 从本地存储获取游客token
		this.tourists_token = localStorage.getItem('kefu_tourists_token') || '';

		this.initWebSocket();
	},

	// 组件挂载后执行
	mounted() {
		// 打印接收到的参数
		// console.log('接收到的参数:', {
		//     referrer: this.referrer,
		//     encryptUserInfo: this.encryptUserInfo,
		//     source: this.source,
		// });

		// 聊天区域实例
		globalMixin.state.chatMessagesRef = this.$refs.chatMessages;

		// 添加鼠标事件监听器
		document.addEventListener('mousemove', this.onDrag);
		document.addEventListener('mouseup', this.stopDrag);

		// 监听键盘事件，按下 ESC 键关闭聊天窗口
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				globalMixin.state.showKefuButton = false;
			}
		});

		// 点击其他区域，关闭所有消息的撤回弹窗
		document.addEventListener('click', (e) => {
			this.session_messages.forEach((msg) => (msg.isrevoke = false));
		});

		// 暴露组件实例，供外部通过 window.CustomerService.ChatWindow.methods.onClickShowKefu() 调用时使用
		// 因为 ChatWindow 是组件配置对象（非 Vue 实例），直接调用其 methods 会丢失 this 上下文
		if (typeof window !== 'undefined' && window.CustomerService) {
			window.CustomerService.instance = this;
		}
	},

	// 组件销毁前执行
	beforeDestroy() {
		// 移除鼠标事件监听器
		document.removeEventListener('mousemove', this.onDrag);
		document.removeEventListener('mouseup', this.stopDrag);

		// 停止未读消息定时器
		// this._stopUnreadMessagesTimer();

		// 断开WebSocket连接
		if (this.indexSocket) {
			globalMixin.state.indexSocket = null;
		}

		// 清理外部暴露的实例引用
		if (typeof window !== 'undefined' && window.CustomerService && window.CustomerService.instance === this) {
			window.CustomerService.instance = null;
		}
	},

	// 方法
	methods: {
		...globalMixin.methods,

        // 订单弹窗类名
        getOrderPopoverClass(orderTabActive) {
            let suffix = '';
            
            if ([1, 2].includes(orderTabActive)) {
                suffix = 'pubg-carmi-list';
            } else if ([3].includes(orderTabActive)) {
                suffix = 'sjz-rental-list';
            } else {
                suffix = 'sjz-crash-list';
            }

            return `order-popover-container-${suffix}`;
        },

        // 订单弹窗类名
        getOrderPopoverItemClass(orderTabActive) {
            let suffix = '';
            
            if ([1, 2].includes(orderTabActive)) {
                suffix = 'pubg-carmi-list-item';
            } else if ([3].includes(orderTabActive)) {
                suffix = 'sjz-rental-list-item';
            } else {
                suffix = 'sjz-crash-list-item';
            }

            return `order-popover-container-${suffix}`;
        },

		/**
		 * 初始化WebSocket
		 */
		async initWebSocket() {
			const that = globalMixin.state;
			try {
				// 调用初始化接口
				let res = await initialize({ modulename: 'index', referrer: this.referrer || '', kefu_tourists_token: this.tourists_token || '', encryptUserInfo: this.encryptUserInfo ? encodeURIComponent(this.encryptUserInfo) : '', source: this.source || '' });
				if (res.code != 1) {
					that.indexSocket = null;
					this.$message.error(res.msg || '初始化失败');
					return;
				}
				let date = res.data;
				// console.log('initWebSocket date:', date);

				if (date.new_msg) {
					if (that.showKefuButton) return;
					playNotificationSound();

					if (that.tipTimer) {
						clearTimeout(that.tipTimer);
						that.tipTimer = null;
					}

					that.tipContent = date.last_message || '';
					that.tipVisible = true;
					// 2秒后隐藏提示
					that.tipTimer = setTimeout(() => {
						that.tipVisible = false;
						that.tipContent = '';
						that.tipTimer = null;
					}, 2000);
				}

				// 保存用户信息和token
				that.user_info = date.user_info || {};
				that.fast_reply = date.fast_reply || [];
				that.platform_options = date.config.platform_options;
				this.tourists_token = date.token_list.kefu_tourists_token || '';
				if (date.product_detail) {
					that.automaticallyProductInfo = date.product_detail;
					that.automaticallyProductShow = true;
				} else {
					that.automaticallyProductShow = false;
				}
				localStorage.setItem('kefu_tourists_token', this.tourists_token || '');

				let socketUrl;
				if (date.token_list.kefu_token) {
					socketUrl = `${configInfo.wssApiDomain}/?modulename=index&kefu_tourists_token=${this.tourists_token || ''}&token=${date.token_list.kefu_token || ''}`;
				} else {
					socketUrl = `${configInfo.wssApiDomain}/?modulename=index&kefu_tourists_token=${this.tourists_token || ''}`;
				}
				// 创建WebSocket实例
				that.indexSocket = createWebSocket(socketUrl);

                // 监听连接状态变化，同步到 wsConnected
                this.indexSocket.onStatusChange((isConnected) => {
                    that.wsConnected = isConnected;
                    // 连接成功时启动未读消息定时器，断开时停止
                    // if (isConnected) {
                    //     this._startUnreadMessagesTimer();
                    // } else {
                    //     this._stopUnreadMessagesTimer();
                    // }
                });

				// 等待WebSocket连接成功
				await this.waitForWebSocketConnection();
				console.log('WebSocket连接成功', this.waitForWebSocketConnection());

				// 先移除旧的消息处理器
				if (this._defaultMessageHandler) {
					this.indexSocket.off('default', this._defaultMessageHandler);
				}

				// 注册消息处理器（保存引用以便后续移除）
				this._defaultMessageHandler = (message) => {
					console.log('收到WebSocket消息:', message);
					// 处理WebSocket消息
					if (this[message.msgtype]) {
						this[message.msgtype](message);
					} else {
						console.log('未处理的消息类型:', message.msgtype, message);
					}
				};
				this.indexSocket.on('default', this._defaultMessageHandler);
			} catch (error) {
				console.error('初始化WebSocket失败:', error);
				this.$message.error('初始化失败，请刷新页面重试');
				that.indexSocket = null;
			}
		},

		/**
		 * 等待WebSocket连接成功
		 * 使用 onStatusChange 回调替代 setInterval 轮询，更可靠
		 * @returns {Promise}
		 */
		waitForWebSocketConnection() {
			return new Promise((resolve, reject) => {
				// 更严格的连接状态检查
				const checkConnection = () => {
					// 检查真实的 WebSocket 状态
					if (this.indexSocket.ws && 
						this.indexSocket.ws.readyState === WebSocket.OPEN) {
						return true;
					}
					return false;
				};

				// 如果已经真正连接，直接返回
				if (checkConnection()) {
					console.log('[WS] 连接已就绪');
					resolve();
					return;
				}

				let timeoutId;
				let unsubscribe;
				let isResolved = false;

				const cleanup = () => {
					if (timeoutId) clearTimeout(timeoutId);
					if (unsubscribe) unsubscribe();
				};

				// 超时处理
				timeoutId = setTimeout(() => {
					if (!isResolved) {
						isResolved = true;
						cleanup();
						console.error('[WS] 连接超时，当前状态:', 
							this.indexSocket.ws?.readyState);
						reject(new Error('WebSocket连接超时'));
					}
				}, 10000);

				// 监听状态变化
				unsubscribe = this.indexSocket.onStatusChange((isConnected) => {
					if (!isResolved && isConnected && checkConnection()) {
						isResolved = true;
						cleanup();
						console.log('[WS] 连接成功');
						resolve();
					}
				});

				// 如果还没开始连接，尝试连接
				if (!this.indexSocket.ws || 
					this.indexSocket.ws.readyState === WebSocket.CLOSED) {
					console.log('[WS] 尝试建立连接');
					this.indexSocket.connect();
				}
			});
		},

		// 切换客服
		onClickKefu(session) {
			// console.log('session', session);
			if (this.activeSession.id == session.id) return;
			// 设置当前选中会话
			globalMixin.state.activeSession = session;
			// 重置记录当前会话框 用户发送消息数量 + 和客服发送消息数量
			globalMixin.state.unexpected_records = 0;
			// 清空当前会话框 消息记录
			globalMixin.state.session_messages = [];
			// 清空当前会话列表 中的未读消息数量
			if (session.session_type == 0) {
				// 私聊
				// 私聊：更新私聊、全部列表
				globalMixin.state.session_list.all = globalMixin.state.session_list.all.map((item) => (item.id == session.id ? { ...item, unread_msg_count: 0 } : item));
				globalMixin.state.session_list.private = globalMixin.state.session_list.private.map((item) => (item.id == session.id ? { ...item, unread_msg_count: 0 } : item));
			} else {
				// 群聊
				// 群聊：更新群聊列表、全部列表
				globalMixin.state.session_list.all = globalMixin.state.session_list.all.map((item) => (item.id == session.id ? { ...item, unread_msg_count: 0 } : item));
				globalMixin.state.session_list.group = globalMixin.state.session_list.group.map((item) => (item.id == session.id ? { ...item, unread_msg_count: 0 } : item));
			}
			// 获取聊天记录
			this.indexSocket.send({
				c: 'Message',
				a: 'chatRecord',
				data: {
					session_id: this.activeSession.id, // 会话ID
					page: 1, // 下一页页码
					unexpected_records: this.unexpected_records // 意外记录数
				}
			});
			// 设置消息已读
			// this.indexSocket.send({
			// 	c: 'Message',
			// 	a: 'readMessage',
			// 	data: {
			// 		record_id: 'all',
			// 		session_id: this.activeSession.id
			// 	}
			// });
			// 自动滚动到底部
			setTimeout(() => {
				const chatMessages = this.chatMessagesRef;
				if (chatMessages) {
					chatMessages.scrollTop = chatMessages.scrollHeight;
				}
			}, 100);
		},

		// 关闭自动发送的商品弹窗
		onClickAutomaticallyProductClose() {
			globalMixin.state.automaticallyProductShow = false;
		},

		// 快速回复
		onClickFastReply(reply) {
            if (this.isBlack) return this.$toast.show('您已被拉黑，无法继续聊天！');
            // 联系微信客服
            if (reply.id == 20) window.open('https://work.weixin.qq.com/kfid/kfc9ac150ab8e9ea4d3', '_blank');
            
			// 生成消息ID
			const message_id = this.generateMessageId();

			// 发送请求
			this.indexSocket.send({
				c: 'Message', // 控制器
				a: 'sendMessage', // 动作
				data: {
					message: reply.content, // 消息内容（包含图片）
					message_type: 0, // 自动判断消息类型
					session_id: this.activeSession.id || '', // 当前会话ID
					token: this.tourists_token || '', // 用户token，校验登录态
					modulename: 'index', // 模块名
					message_id: message_id // 消息唯一ID
				}
			});

			// 构建本地消息插入聊天框
			this.buildRecord({ message: reply.content, message_type: 0 }, 'append', message_id);
		},

		// 催一催
		urgeReply() {
			const currentTime = Date.now();
			const timeDiff = currentTime - this.lastUrgeTime;
			const oneMinute = 60 * 1000;

			if (timeDiff < oneMinute) {
				const remainingSeconds = Math.ceil((oneMinute - timeDiff) / 1000);
                this.$toast.show(`请${remainingSeconds}秒后再试`);
				return;
			}

			this.lastUrgeTime = currentTime;

			// 生成消息ID
			const message_id = this.generateMessageId();

			// 发送请求
			this.indexSocket.send({
				c: 'Message', // 控制器
				a: 'sendMessage', // 动作
				data: {
					message: '已为您督促客服，烦请耐心等待...', // 消息内容（包含图片）
					message_type: 11, // 自动判断消息类型
					session_id: this.activeSession.id || '', // 当前会话ID
					token: this.tourists_token || '', // 用户token，校验登录态
					modulename: 'index', // 模块名
					message_id: message_id // 消息唯一ID
				}
			});

			// 构建本地消息插入聊天框
			this.buildRecord({ message: '已为您督促客服，烦请耐心等待...', message_type: 11 }, 'append', message_id);
		},
        
        // 复制文本
        copyText(number) {
            copy(number);
        },

        // 复制图片到剪贴板
        async copyImage(url) {
            try {
                const response = await fetch(url);
                const blob = await response.blob();
                if (navigator.clipboard && window.ClipboardItem) {
                    const item = new ClipboardItem({ [blob.type]: blob });
                    await navigator.clipboard.write([item]);
                    this.$toast.show('图片已复制');
                } else {
                    copy(url);
                    this.$toast.show('图片链接已复制');
                }
            } catch (error) {
                console.error('复制图片失败:', error);
                copy(url);
                this.$toast.show('图片链接已复制');
            }
        },

		// 商品卡片 - 跳转链接
		onClickJumpLink(item) {
			console.log('item', item);
			if(item.message_type == 5) return;
			if (item.url) window.open(item.url, '_blank');
		},

		// 撤回消息
		onClickRevokeMessage(item) {
            if (this.isBlack) return this.$toast.show('您已被拉黑，无法继续聊天！');
			// 发送请求
			this.indexSocket.send({
				c: 'Message', // 控制器
				a: 'recallMessage', // 动作
				data: {
					id: item.id,
					session_id: item.session_id
				}
			});
		},

		// @用户
		onClickMultiUser(item) {
            if (this.isBlack) return this.$toast.show('您已被拉黑，无法继续聊天！');
			if (this.activeSession.session_type != 1) return;
			const message_id = this.generateMessageId();

			this.indexSocket.send({
				c: 'Message',
				a: 'sendMessage',
				data: {
					message: `[${this.user_info.nickname} @${item.name}]`,
					message_type: 10,
					session_id: this.activeSession.id || '',
					token: this.tourists_token || '',
					modulename: 'index',
					message_id
				}
			});

			this.buildRecord({ message: `[${this.user_info.nickname} @${item.name}]`, message_type: 10 }, 'append', message_id);
		},

		/**
		 * 点击选择 emoji 图标
		 * @param {string} category 分类内容
		 */
		selectCategory(category) {
			const editor = document.getElementById('message-editor');
			if (!editor) return;

			// 此时编辑器焦点还在，选区还在
			const selection = window.getSelection();

			let range;
			if (selection.rangeCount > 0) {
				range = selection.getRangeAt(0);

				// 确认选区在编辑器内
				if (!editor.contains(range.commonAncestorContainer)) {
					// 不在编辑器内，放末尾
					editor.focus();
					range = document.createRange();
					range.selectNodeContents(editor);
					range.collapse(false);
				}
			} else {
				// 没有选区，放末尾
				editor.focus();
				range = document.createRange();
				range.selectNodeContents(editor);
				range.collapse(false);
			}

			// 删除选中内容
			range.deleteContents();

			// 插入 emoji
			const textNode = document.createTextNode(category);
			range.insertNode(textNode);

			// 光标移到 emoji 后面
			range.setStartAfter(textNode);
			range.collapse(true);

			// 更新选区
			selection.removeAllRanges();
			selection.addRange(range);

			// 保持编辑器焦点
			editor.focus();

			// 触发输入同步
			this.handleInput();
		},

		// 上传图片
		uploadImage() {
			// 创建隐藏的文件输入框
			const input = document.createElement('input');
			input.type = 'file';
			input.accept = 'image/jpeg,image/jpg,image/png,image/gif,image/webp,image/bmp';

			input.onchange = async (e) => {
				const file = e.target.files[0];
				if (!file) return;

				let data = await uploadFileToAliyunOSS({
                    file: file,
                    userId: '',
                });
				// console.log('图片data', data);
				if (data.code == 200) {
					// 生成消息ID
					const message_id = this.generateMessageId();

					// 发送请求
					this.indexSocket.send({
						c: 'Message', // 控制器
						a: 'sendMessage', // 动作
						data: {
							message: data.fileUrl, // 消息内容（包含图片）
							message_type: 1, // 自动判断消息类型
							session_id: this.activeSession.id || '', // 当前会话ID
							token: this.tourists_token || '', // 用户token，校验登录态
							modulename: 'index', // 模块名
							message_id: message_id // 消息唯一ID
						}
					});

					// 构建本地消息插入聊天框
					this.buildRecord({ message: data.fileUrl, message_type: 1 }, 'append', message_id);
				}
			};

			input.click();
		},

		// v-html渲染的内容 点击预览图片
		previewHtmlImage(event) {
			if (event.target.tagName.toLowerCase() === 'img') {
				this.previewImage(event.target.src);
			}
		},

		// 预览图片
		previewImage(url) {
			window.open(url, '_blank');
		},

		// 上传视频
		uploadVideo() {
			// 创建隐藏的文件输入框
			const input = document.createElement('input');
			input.type = 'file';
			input.accept = 'video/*';

			input.onchange = async (e) => {
				const file = e.target.files[0];
				if (!file) return;

				let data = await uploadFileToAliyunOSS({
                    file: file,
                    userId: '',
                });
				// console.log('视频data', data);
				if (data.code == 200) {
					// 生成消息ID
					const message_id = this.generateMessageId();

					// 发送请求
					this.indexSocket.send({
						c: 'Message', // 控制器
						a: 'sendMessage', // 动作
						data: {
							message: data.fileUrl, // 消息内容（包含视频）
							message_type: 6, // 自动判断消息类型
							session_id: this.activeSession.id || '', // 当前会话ID
							token: this.tourists_token || '', // 用户token，校验登录态
							modulename: 'index', // 模块名
							message_id: message_id // 消息唯一ID
						}
					});

					// 构建本地消息插入聊天框
					this.buildRecord({ message: data.fileUrl, message_type: 6 }, 'append', message_id);
				}
			};

			input.click();
		},

		// 处理右键点击事件
		handleRightClick(item) {
			if (item.sender != 'me') return;
			globalMixin.state.session_messages.forEach((msg) => (msg.isrevoke = false));
			item.isrevoke = true;
		},

		/**
		 * 发送消息
		 */
		sendMessage() {
			if (!this.editorHtmlContent.trim()) return;

			// console.log('发送消息 - HTML内容（包含图片）:', this.editorHtmlContent);
			// console.log('发送消息 - 纯文本内容:', this.editorTextContent);
			// 生成消息ID
			const message_id = this.generateMessageId();

			// 发送请求
			this.indexSocket.send({
				c: 'Message', // 控制器
				a: 'sendMessage', // 动作
				data: {
					message: this.editorHtmlContent, // 消息内容（包含图片）
					message_type: 0, // 自动判断消息类型
					session_id: this.activeSession.id || '', // 当前会话ID
					token: this.tourists_token || '', // 用户token，校验登录态
					modulename: 'index', // 模块名
					message_id: message_id // 消息唯一ID
				}
			});

			// 构建本地消息插入聊天框
			this.buildRecord({ message: this.editorHtmlContent, message_type: 0 }, 'append', message_id);

			// 清空编辑器
			const editor = document.getElementById('message-editor');
			editor.innerHTML = '';
			this.handleInput();
		},

		// 聊天记录区域滚动事件
		handleScroll() {
			if (this.loadingMessages) return;
			this.session_messages.forEach((msg) => (msg.isrevoke = false));
			const chatMessages = this.chatMessagesRef;
			if (!chatMessages) return;

			if (chatMessages.scrollTop < 50 && this.pageParams.next_page != 'done') {
				// 防止频繁触发（防抖处理）
				if (Date.now() - this.lastScrollTime < 500) return;
				this.lastScrollTime = Date.now();
				globalMixin.state.loadingMessages = true; // 立即锁住，防止快速滚动重复触发

				// 发送请求
				this.indexSocket.send({
					c: 'Message', // 控制器
					a: 'chatRecord', // 动作
					data: {
						session_id: this.activeSession.id, // 会话ID
						page: this.pageParams.next_page, // 下一页页码
						unexpected_records: this.unexpected_records // 意外记录数
					}
				});
			}
		},

		// 工具栏点击事件
		onClickToolItem(type) {
			if (!this.encryptUserInfo) {
				this.$toast.show('请先登录,再进行工具栏操作！')
				setTimeout(() => {
					// 主站、分站
					if ([1, 2].includes(this.platform_options)) {
						window.location.href = `/login.html?redirect=${window.location.pathname}`;
					}
				}, 500)
				return;
			}

            const configGroup = TOOL_ITEM_CONFIG[type];
            if (!configGroup) return;

            const thatGlobal = globalMixin.state;
            Object.values(configGroup).forEach(({ control, action, pageKey }) => {
                this.indexSocket.send({
                    c: control,
                    a: action,
                    data: {
                        page: thatGlobal[pageKey]?.page || 1,
                    }
                });
            });
		},

		// 咨询商品切换 tabs
		onClickConsultProduct(id) {
			globalMixin.state.consultProductTabActive = id;
		},

		// 我的订单切换 tabs
		onClickOrderTabs(id) {
			globalMixin.state.orderTabActive = id;
		},

        // 我的商品切换 tabs
        onClickMyProductTabs(id) {
			globalMixin.state.myProductTabActive = id;
		},

        // 处理图片
        handleImage(imgs) {
            if (!imgs) return '';
            return imgs.split(',')[0];
        },

		// 发送商品
		sendProduct(item, message_type, type) {
            if (this.isBlack) return this.$toast.show('您已被拉黑，无法继续聊天！');
            
			const message_id = this.generateMessageId();
			let productInfo;

			switch (type) {
				case 1:
					// 咨询商品 - 点击发送商品事件
					productInfo = this.buildProductInfo(item, message_type);
					break;
				case 2:
					// 我的订单 - 点击发送订单事件
					productInfo = `id=${item.id}#message_type=${message_type}#pic_image=${item.product_pic_image}#name=${item.product_name}#arm_tabs=【商品编号】${item.product_number}#number=${item.out_trade_no}#price=${item.amount}#url=`;
					break;
                case 5:
                    // 我的订单【三角洲-订单卡片】 - 点击发送订单事件
                    productInfo = this.buildProductInfo(item, message_type);
                    break;
                case 7:
                    // 我的订单【三角洲-撞车卡片】 - 点击发送订单事件
                    productInfo = this.buildProductInfo(item, message_type);
                    break;
				case 3:
					// 我的商品 - 点击发送商品事件
					productInfo = `id=${item.id}#message_type=${message_type}#pic_image=${item.pic_image}#name=${item.name}#arm_tabs=${item.arm_tab_ids}#number=${item.number}#price=${item.price}#url=${item.url}`;
					break;
                case 6:
					// 我的商品【三角洲-商品卡片】 - 点击发送商品事件
					productInfo = this.buildProductInfo(item, message_type);
					break;
				case 4:
					// 账号详情打开客服 - 点击发送当前浏览商品
					productInfo = this.buildProductInfo(item, message_type);
					this.onClickAutomaticallyProductClose(); // 关闭自动发送当前浏览商品
					break;
				default:
					break;
			}

			// 发送请求
			this.indexSocket.send({
				c: 'Message', // 控制器
				a: 'sendMessage', // 动作
				data: {
					message: productInfo, // 消息内容（包含图片）
					message_type, // 自动判断消息类型
					session_id: this.activeSession.id || '', // 当前会话ID
					token: this.tourists_token || '', // 用户token，校验登录态
					modulename: 'index', // 模块名
					message_id: message_id // 消息唯一ID
				}
			});

			// 构建本地消息插入聊天框
			this.buildRecord({ message: productInfo, message_type }, 'append', message_id);
		},

		// 处理分页切换事件
		handleCurrentChange(page, type) {
			let that = globalMixin.state;

			// 映射参数名
			const mapParams = {
				product: 'productParams',
				sjzRental: 'sjzRentalParams',
				secondHand: 'secondHandParams',
				carmi: 'carmiParams',
				browse: 'browseParams',
				collect: 'collectParams',
				delta: 'deltaRentalParams',
				crash: 'deltaCrashParams'
			};

			// 映射动作名
			const mapAction = {
				product: 'userFlowProduct',
				sjzRental: 'userSjzProduct',
				secondHand: 'orderList',
				carmi: 'carmiOrderList',
				browse: 'consultGoods',
				collect: 'collectList',
				delta: 'rentalOrderList',
				crash: 'collisionOrderList'
			};

			// 分页切换时，更新 loading 状态
			that[mapParams[type]].loading = true;
			that[mapParams[type]].page = page;

			this.indexSocket.send({
				// c: type == 'delta' ? 'OrderManager' : 'Message',
				c: ['delta', 'crash'].includes(type) ? 'OrderManager' : ['sjzRental'].includes(type) ? 'SjzManager' : 'Message',
				a: mapAction[type],
				data: { 
					page: that[mapParams[type]].page
				}
			});
		},

		// ************************************************************* 以下输入框事件
		// 处理粘贴事件 (核心)
		handlePaste(event) {
			// 1. 阻止默认粘贴行为，让我们自己来处理
			event.preventDefault();

			const clipboardData = event.clipboardData || window.clipboardData;
			const items = clipboardData.items;

			// 2. 检查剪贴板中是否有图片
			let hasImage = false;
			for (let i = 0; i < items.length; i++) {
				if (items[i].type.indexOf('image') !== -1) {
					hasImage = true;
					const file = items[i].getAsFile();
					this.uploadImageFromClipboard(file); // 上传图片
					break;
				}
			}

			// 3. 如果没有图片，再处理文本（保留格式）
			if (!hasImage) {
				const text = clipboardData.getData('text/plain');
				const html = clipboardData.getData('text/html');

				// 优先粘贴带格式的 HTML，否则粘贴纯文本
				if (html) {
					this.insertHtmlAtCursor(html);
				} else if (text) {
					this.insertTextAtCursor(text);
				}
			}
		},

		// 上传剪贴板中的图片
		async uploadImageFromClipboard(file) {
			// 这里调用你的上传接口
			// 参考你之前截图功能中的 handleScreenshotResult 或 uploadImage 方法
			const formData = new FormData();
			formData.append('file', file);
			formData.append('type', 'chat_image');

			let data = await uploadFileToAliyunOSS({
                file: file,
                userId: '',
            });
			if (data.code == 200) {
				this.insertImageToEditor(data.fileUrl);
			}
		},

		// 将图片插入到编辑器中
		insertImageToEditor(imageUrl) {
			const editor = document.getElementById('message-editor');
			if (!editor) return;

			// 在光标位置插入 <img> 标签
			const imgHtml = `<img src="${imageUrl}" alt="图片" style="max-width: 200px; max-height: 150px; border-radius: 5px; object-fit: cover;" />`;

			if (document.selection) {
				// IE
				const range = document.selection.createRange();
				range.pasteHTML(imgHtml);
			} else if (editor.selectionStart !== undefined) {
				// 普通 input/textarea
				// contenteditable 不能用这种方式，但这里是 div
			} else {
				// 标准方式：在光标位置插入
				const selection = window.getSelection();
				if (!selection.rangeCount) return;

				const range = selection.getRangeAt(0);
				range.deleteContents(); // 删除选中的内容

				// 创建图片元素
				const img = document.createElement('img');
				img.src = imageUrl;
				img.style.maxWidth = '200px';
				img.style.maxHeight = '150px';
				img.style.borderRadius = '5px';
				img.style.margin = '5px 0';
				img.alt = '图片';

				range.insertNode(img);
				range.collapse(false); // 将光标移动到图片后面

				// 清理选区
				selection.removeAllRanges();
				selection.addRange(range);
			}

			// 触发输入事件，更新数据
			this.handleInput();
		},

		// 处理输入事件（同步内容）
		handleInput() {
			const editor = document.getElementById('message-editor');
			if (editor) {
				// 获取HTML内容（包含图片）
				this.editorHtmlContent = editor.innerHTML;

				// 获取纯文本内容（不包含图片）
				this.editorTextContent = editor.innerText || editor.textContent;

				// console.log('HTML内容（包含图片）:', this.editorHtmlContent);
				// console.log('纯文本内容（不包含图片）:', this.editorTextContent);
			}
		},

		// 插入纯文本到光标位置
		insertTextAtCursor(text) {
			const editor = document.getElementById('message-editor');
			const selection = window.getSelection();
			if (!selection.rangeCount) return;

			const range = selection.getRangeAt(0);
			range.deleteContents();

			const textNode = document.createTextNode(text);
			range.insertNode(textNode);
			range.collapse(false);

			selection.removeAllRanges();
			selection.addRange(range);

			this.handleInput();
		},

		// 插入HTML到光标位置
		insertHtmlAtCursor(html) {
			const editor = document.getElementById('message-editor');
			const selection = window.getSelection();
			if (!selection.rangeCount) return;

			const range = selection.getRangeAt(0);
			range.deleteContents();

			const fragment = range.createContextualFragment(html);
			range.insertNode(fragment);
			range.collapse(false);

			selection.removeAllRanges();
			selection.addRange(range);

			this.handleInput();
		},

		// 处理 Enter 键（区分中英文输入状态）
		handleEnterKey(event) {
			// keyCode 229 或 isComposing 为 true，说明正在使用输入法组合文字
			// 此时按 Enter 是确认候选词，不是发送消息
			if (event.isComposing || event.keyCode === 229) {
				return; // 直接放行，让输入法处理
			}

			// 确认不是输入法状态，执行发送
			this.sendMessage();
		},

		// 插入换行（Shift+Enter）
		insertNewline() {
			const editor = document.getElementById('message-editor');
			const selection = window.getSelection();
			if (!selection.rangeCount) return;

			const range = selection.getRangeAt(0);
			const br = document.createElement('br');
			range.insertNode(br);
			range.collapse(false);

			selection.removeAllRanges();
			selection.addRange(range);

			this.handleInput();
		},

		// ************************************************************* 以下拖拽事件
		// 开始拖拽
		startDrag(e) {
			// 只有在点击浮标容器或聊天窗口头部时才启动拖拽
			if (!e.target.closest('.kefu_button_container') && !e.target.closest('.logo-container')) {
				return;
			}

			// 阻止默认行为，避免选中文本等
			e.preventDefault();

			// 设置拖拽状态
			this.isDragging = true;
			this.hasMoved = false;

			// 记录起始位置
			this.startX = e.clientX;
			this.startY = e.clientY;

			// 获取容器位置
			const container = document.getElementById('kefu-container');
			const rect = container.getBoundingClientRect();

			this.startLeft = rect.left;
			this.startTop = rect.top;
		},

		// 拖拽过程
		onDrag(e) {
			// 如果不在拖拽状态，直接返回
			if (!this.isDragging) return;

			// 阻止默认行为
			e.preventDefault();

			// 计算鼠标移动距离
			const dx = e.clientX - this.startX;
			const dy = e.clientY - this.startY;

			// 检测是否有明显移动（超过5px）
			if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
				this.hasMoved = true;
			}

			// 获取容器信息
			const container = document.getElementById('kefu-container');
			const rect = container.getBoundingClientRect();

			// 计算新位置
			let newLeft = this.startLeft + dx;
			let newTop = this.startTop + dy;

			// 获取视口尺寸
			const viewportWidth = window.innerWidth;
			const viewportHeight = window.innerHeight;

			// 边界限制，添加边框距离
			const margin = 10;
			newLeft = Math.max(margin, Math.min(newLeft, viewportWidth - rect.width - margin));
			newTop = Math.max(margin, Math.min(newTop, viewportHeight - rect.height - margin));

			// 更新容器位置
			container.style.left = `${newLeft}px`;
			container.style.top = `${newTop}px`;
			container.style.transform = 'none';
		},

		// 停止拖拽
		stopDrag() {
			const container = document.getElementById('kefu-container');
			if (container) {
				// 将拖拽状态传递给容器元素
				container.__hasMoved = this.hasMoved;
			}
			// 重置拖拽状态
			this.isDragging = false;
		},

		// 显示聊天窗口
		showChat(buttonPos) {
			this.isChatVisible = true;

			// 记录按钮位置（用于关闭后回到该位置）
			if (buttonPos) {
				this.buttonPosition = buttonPos;
			}

			// 隐藏浮标（打开期间不显示，脉冲圆环独立于浮标）
			this.kefuButtonVisible = false;

			// 计算浮标中心在聊天窗口中的相对位置（作为 transform-origin）
			// 聊天窗口尺寸：1100 x 720，浮标尺寸：140 x 140
			const chatW = 1100;
			const chatH = 720;
			const btnW = 140;
			const btnH = 140;

			// 浮标中心相对视口的坐标
			const btnCenterX = this.buttonPosition.x + btnW / 2;
			const btnCenterY = this.buttonPosition.y + btnH / 2;

			// 聊天窗口打开后中心相对视口的坐标（居中）
			const chatCenterX = window.innerWidth / 2;
			const chatCenterY = window.innerHeight / 2;

			// 将浮标中心转换为聊天窗口内部的百分比坐标
			const originX = ((btnCenterX - (chatCenterX - chatW / 2)) / chatW) * 100;
			const originY = ((btnCenterY - (chatCenterY - chatH / 2)) / chatH) * 100;

			this.chatOriginStyle = {
				transformOrigin: `${Math.round(originX)}% ${Math.round(originY)}%`
			};

			// 居中展示
			const container = document.getElementById('kefu-container');
			container.style.top = '50%';
			container.style.left = '50%';
			container.style.transform = 'translate(-50%, -50%)';
		},

		// 隐藏聊天窗口（开始关闭动画）
		hideChat() {
			// 已经关闭则不重复处理（避免 watch 回调二次调用）
			if (!this.showKefuButton) return;
			// 关键：将 showKefuButton 置为 false，触发 v-show 隐藏 + 关闭动画
			globalMixin.state.showKefuButton = false;
			this.isChatVisible = false;
			// 浮标保持隐藏，关闭动画期间不显示（避免出现在居中位置）
			// 容器位置保持居中，让关闭缩放动画在居中位置播放，缩向浮标原位置
			// 容器复位 + 浮标显示 在 onChatAfterLeave 中处理
		},

		// 关闭动画结束后：容器回到按钮位置，重新显示浮标
		onChatAfterLeave() {
			// 如果聊天窗口又打开了（快速开关），不执行复位
			if (this.showKefuButton) return;
			const container = document.getElementById('kefu-container');
			if (container) {
				container.style.top = `${this.buttonPosition.y}px`;
				container.style.left = `${this.buttonPosition.x}px`;
				container.style.transform = 'none';
			}
			this.kefuButtonVisible = true;
		},

		// 处理点击事件
		onClickShowKefu() {
			// 兼容外部调用：window.CustomerService.ChatWindow.methods.onClickShowKefu()
			// 此时 this 不是 Vue 实例（没有 $refs），需转发给真实的组件实例
			if (!this.$refs) {
				const instance = window.CustomerService && window.CustomerService.instance;
				if (instance && instance !== this) {
					return instance.onClickShowKefu();
				}
			}

			// 检查是否有拖拽行为
			const appContainer = document.getElementById('kefu-container');
			if (appContainer && appContainer.__hasMoved) {
				// 如果有拖拽，不执行点击操作
				appContainer.__hasMoved = false;
				return;
			}

			// 先获取并记录按钮位置（此时按钮还可见，getBoundingClientRect 有效）
			this.buttonPosition = this.getButtonPosition();

			// 触发点击回弹动画
			this.kefuButtonActive = true;
			// 动画结束后关闭标志位，与 CSS 动画时长保持一致（450ms）
			clearTimeout(this._kefuBtnTimer);
			this._kefuBtnTimer = setTimeout(() => {
				this.kefuButtonActive = false;
				this.kefuButtonPressed = false;
			}, 450);

            // 主站
            if (!this.referrer.includes('https://table.xianyouhe.com')) {
                if (this.referrer.includes('https://www.xianyouhe.com')) {
                    if (!this.encryptUserInfo) {
                        this.$toast.show('当前暂未登录，登录后即可参与聊天～');
                        setTimeout(() => {
                            if ('https://www.xianyouhe.com/login.html' == window.location.href) return;
                            window.location.href = 'https://www.xianyouhe.com/login.html';
                        }, 400);
                        return;
                    }
                }
                // 分站
                else if (this.referrer.includes('xianyouhe.com') || this.referrer.includes('yihaolianmeng.com') || this.referrer.includes('https://www.7haoyou.com') || this.referrer.includes('https://www.12pubg.com')) {
                    if (!this.encryptUserInfo) {
                        this.$toast.show('当前暂未登录，登录后即可参与聊天～');
                        setTimeout(() => {
                            let loginUrl = `${this.referrer.split('.')[0]}.${this.referrer.split('.')[1]}.com/login.html`
                            if (loginUrl == window.location.href) return;
                            window.location.href = loginUrl;
                        }, 400);
                        return;
                    }
                }
                // 分站 - 特殊域名
                else if (this.referrer.includes('https://12pubg.com') || this.referrer.includes('https://7haoyou.com')) {
                    if (!this.encryptUserInfo) {
                        this.$toast.show('当前暂未登录，登录后即可参与聊天～');
                        setTimeout(() => {
                            let loginUrl = `${this.referrer.split('.')[0]}.com/login.html`
                            if (loginUrl == window.location.href) return;
                            window.location.href = loginUrl;
                        }, 400);
                        return;
                    }
                }
            }

			// 打开聊天窗口
			this.openChat();
		},

		// 打开聊天窗口
		openChat() {
			globalMixin.state.showKefuButton = true;
		},

		// 获取客服按钮位置
		getButtonPosition() {
			if (this.$refs.buttonContainer) {
				const rect = this.$refs.buttonContainer.getBoundingClientRect();
				return {
					x: rect.left,
					y: rect.top
				};
			}
			return { x: 0, y: 0 };
		}
	}
};
</script>

<style scoped lang="scss">
@import '@/style/global/reset.scss';

/* Mac App 缩放打开/收起动画 - 优化版 */
.kefu-zoom-enter-active {
	transition: opacity 0.26s cubic-bezier(0.22, 0.61, 0.36, 1),
		transform 0.38s cubic-bezier(0.16, 1, 0.3, 1);
	will-change: transform, opacity;
}

.kefu-zoom-leave-active {
	transition: opacity 0.18s cubic-bezier(0.4, 0, 0.6, 1),
		transform 0.26s cubic-bezier(0.7, 0, 0.84, 0);
	will-change: transform, opacity;
}

.kefu-zoom-enter,
.kefu-zoom-leave-to {
	opacity: 0;
	transform: scale(0.18) translateY(12px);
	pointer-events: none;
}

/* 客服浮标点击回弹动画：按下缩小 -> 回弹轻微过冲 -> 恢复正常 */
@keyframes kefuButtonPop {
	0% {
		transform: scale(0.9);
	}
	60% {
		transform: scale(1.08);
	}
	100% {
		transform: scale(1);
	}
}

/* 客服容器 */
#kefu-container {
	width: max-content;
	height: max-content;
	position: fixed;
	bottom: 100px;
	right: calc((100vw - 1500px) / 2);
	z-index: 9999;

	/* 客服浮标 */
	.kefu_button_container {
		cursor: move; // 鼠标悬停时显示移动光标
		position: relative;
		transition: transform 0.18s cubic-bezier(0.22, 0.61, 0.36, 1);
		transform-origin: center center;
		will-change: transform;

		// 按下状态：轻微缩小
		&.kefu-button-pressed {
			transform: scale(0.9);
			transition: transform 0.12s cubic-bezier(0.4, 0, 0.6, 1);
		}

		// 点击激活：回弹放大 + 轻微弹动
		&.kefu-button-active {
			animation: kefuButtonPop 0.45s cubic-bezier(0.16, 1, 0.3, 1);
		}

		.kefu_button_img {
			width: 100%;
			height: 100%;
			-webkit-user-drag: none; // 禁止图片拖拽
			user-select: none;
			-webkit-user-select: none;
			transition: filter 0.2s ease;
		}

		// 按下时浮标图片略微提亮
		&.kefu-button-pressed .kefu_button_img {
			filter: brightness(1.05) saturate(1.1);
		}

		.new-message {
			position: absolute;
			top: 50%;
			right: 140px;
			transform: translateY(-50%);
			background: #303133;
			padding: 10px 8px;
			border-radius: 4px;

			&-text {
				width: max-content;
				max-width: 150px;
				font-size: 12px;
				line-height: 16px;
				font-weight: 400;
				color: rgba(255, 255, 255, 1);
			}

			&::after {
				content: '';
				position: absolute;
				top: 50%;
				right: -5px;
				transform: translateY(-50%) rotate(45deg);
				width: 10px;
				height: 10px;
				background: #303133;
			}
		}
        
        .unread-messages-count {
            font-family: DouyinSans-Bold;
            min-width: 26px;
            position: absolute;
			top: -5px;
			right: -5px;
			background: #303133;
			padding: 5px 0px;;
			border-radius: 50%;
            background-color: #f82a5a;
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            text-align: center;
        }
	}

	/* 聊天窗口 */
	.chat-container {
		width: 1100px;
		height: 720px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
		overflow: hidden;
		background: rgba(237, 239, 241, 1);

		.chat-sidebar {
			width: 270px;
			height: 100%;
			background: rgba(247, 248, 250, 1);

			.search-container {
				box-sizing: border-box;
				padding: 0px 11px;

				.logo-container {
					cursor: move; // 鼠标悬停时显示移动光标

					img {
						width: 64px;
						height: 40px;
					}
				}

				.search-wrapper {
					::v-deep(.el-input__inner) {
						color: #606266 !important;
						border-radius: 10px;
						border-radius: 4px !important;
						border: 1px solid #dcdfe6 !important;
						padding-left: 30px !important;
						background-color: #fff !important;

						&:focus {
							border-color: var(--el-kefu-color-primary1) !important;
						}
					}
				}
			}

			.kefu-tab-header {
				box-sizing: border-box;
				padding: 0 11px;

				.kefu-tab-item {
					flex: 1;
					color: rgba(51, 51, 51, 1);
					font-size: 14px;
					font-weight: 400;
					text-align: center;
					box-sizing: border-box;
					padding: 14px 0px 6px;
					position: relative;
					transition: all 0.3s ease;

					.icon-underline {
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						width: 0px;
						height: 2px;
						background: var(--el-kefu-color-primary1);
						transition: width 0.3s ease-in-out;
					}

					&.active {
						color: var(--el-kefu-color-primary1);

						.icon-underline {
							width: 30px;
						}
					}
				}
			}

			.kefu-list {
				height: calc(100% - 127px);
				overflow: auto;

				.kefu-item {
					padding: 9px 14px 11px;

					.avatar-container {
						position: relative;

						.avatar-group {
							width: 40px;
							height: 40px;
							background: rgba(240, 240, 240, 1);
							border-radius: 10px;
							overflow: hidden;

							img {
								width: 100%;
								height: 100%;
							}

							&.avatar-group-1 {
								display: flex;
								flex-wrap: wrap;
								gap: 2px 2px;
								padding: 2px;

								img {
									width: calc(50% - 1px);
									height: calc(50% - 1px);
									border-radius: 2px;
								}
							}
						}

						&.avatar-mask {
							position: relative;

							&::before {
								display: inline-block;
								content: '';
								position: absolute;
								top: 0;
								left: 0;
								z-index: 9;
								width: 100%;
								height: 100%;
								border-radius: 10px;
								background-color: rgb(165, 165, 165, 0.5);
							}
						}

						.unread_msg_count {
							box-sizing: border-box;
							position: absolute;
							top: -5px;
							right: -6px;
							min-width: 12px;
							padding: 4px 4px;
							border-radius: 8px;
							background-color: rgba(254, 53, 93, 1);
							color: rgba(255, 255, 255, 1);
							font-size: 8px;
							line-height: 8px;
							font-weight: 400;
						}
					}

					.info-container {
						width: calc(100% - 54px);

						.name {
							font-size: 14px;
							line-height: 19px;
							color: rgba(68, 76, 105, 1);
						}

                        .status-icon {
                            font-size: 14px;
							line-height: 19px;
                            position: relative;

                            &::after {
                                content: '';
                                position: absolute;
                                top: 50%;
                                transform: translateY(-50%);
                                left: 0;
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                            }

                            &.online {
                                color: var(--el-kefu-color-primary1);
                                
                                &::after {
                                    background-color: var(--el-kefu-color-primary1);
                                }
                            }

                            &.offline {
                                color: rgba(188, 188, 188, 1);
                                
                                &::after {
                                    background-color: rgba(188, 188, 188, 1);
                                }
                            }

                            &.pending {
                                color: rgba(250, 39, 47, 1);
                                
                                &::after {
                                    background-color: rgba(250, 39, 47, 1);
                                }
                            }
                        }

						.official-icon {
							width: 30px;
							height: 16px;
						}

						.last-message {
                            flex: 1;
							color: rgba(165, 165, 165, 1);
							font-size: 12px;
							line-height: 16px;

							&.highlight {
								color: var(--el-kefu-color-primary1);
							}
						}

                        .last-time {
                            width: max-content;
                            color: rgba(165, 165, 165, 1);
							font-size: 12px;
							line-height: 16px;
                        }
					}

					&.active {
						background: rgba(234, 234, 234, 1);
					}
				}

				.empty-container {
					height: 100%;

					.empty-img {
						width: 156px;
						height: 156px;
					}
				}
			}
		}

		.chat-content {
			width: calc(100% - 270px);
			height: 100%;
			background: rgba(237, 239, 241, 1);
			position: relative;

			.chat-header {
				padding: 15px 22px 12px 16px;
				border-bottom: 1px solid rgba(221, 225, 230, 1);

				.header-left {
					font-size: 14px;
					color: rgba(51, 51, 51, 1);
					line-height: 19px;

					.shop-name {
						max-width: 400px;
						position: relative;

						.status-icon {
							position: absolute;
							top: 0;
							right: 0;
							display: inline-block;
							border-radius: 50%;

							&.online {
								color: var(--el-kefu-color-primary1);
							}

							&.pending {
								color: rgba(250, 39, 47, 1);
							}

							&.offline {
								color: rgba(188, 188, 188, 1);
							}
						}
					}

					.kefu-tag {
						color: rgba(51, 51, 51, 1);
						font-size: 10px;
						font-weight: 400;
						line-height: 14px;
						border-radius: 5px;
						padding: 3px 5px;
						background: linear-gradient(-57.65deg, rgba(240, 224, 198, 1) 5.881%, rgba(229, 200, 169, 1) 92.206%);
					}

					.shop-time {
						color: rgba(165, 165, 165, 1);
						font-size: 12px;
					}
				}

				.header-right {
					font-size: 18px;
					color: rgba(0, 0, 0, 1);
				}
			}

            .auto-send-product {
                position: absolute;
				top: 56px;
				left: 3%;
				width: 94%;
				background-color: #fff;
				padding: 10px 15px;
				border-radius: 10px;
				border-bottom: 1px solid rgb(221, 225, 230);
				z-index: 10;
            }

			.automatically-send-product {

				.automatically-send-product-img {
					width: 192px;
					height: 108px;
					border-radius: 8px;
				}

				.automatically-send-product-info {
					width: calc(100% - 192px - 20px - 30px - 80px);

					.automatically-send-product-info-name {
						font-size: 16px;
						line-height: 24px;
						color: rgba(68, 76, 105, 1);
					}

					.automatically-send-product-info-tag {
						font-size: 14px;
						color: #666;
					}

					.automatically-send-product-info-number {
						font-size: 14px;
						color: #666;
					}

					.automatically-send-product-info-price {
						font-size: 26px;
						color: #ff0f23;
    					font-family: DouyinSans-Bold;

						span {
							font-size: 16px;
						}
					}
				}

				.btn-container {
					position: relative;

					.close-btn {
						position: absolute;
						top: 0;
						right: 0;
						font-size: 22px;
						color: var(--el-kefu-color-primary1);
						transition: all 0.3s ease-in-out;

						&:hover {
							transform: rotate(90deg);
						}
					}
				}
			}

            .autodelta-send-product {

                &-number {
                    font-size: 14px;
                    color: #666;
                }

                &-info {

                    &-image {
                        width: 130px;
                        height: 94px;
                        border-radius: 10px;
                        object-fit: cover;
                    }

                    &-name {
                        font-size: 16px;
                        line-height: 24px;
                        color: rgba(68, 76, 105, 1);
                    }

                    &-timer {
                        font-size: 12px;
                        line-height: 16px;
                        color: rgba(51, 51, 51, 1);
                    }

                    &-money {

                        &-lable,
                        &-value {
                            font-size: 14px;
                            text-align: left;
                            color: #606266;
                        }
                    }
                }

                &-footer {
					position: relative;

					.close-btn {
						position: absolute;
						top: -22px;
						right: 0;
						font-size: 22px;
						color: var(--el-kefu-color-primary1);
						transition: all 0.3s ease-in-out;

						&:hover {
							transform: rotate(90deg);
						}
					}
				}
            }

			.chat-messages {
				box-sizing: border-box;
				width: 100%;
				flex: 1;
				overflow: auto;
				padding: 10px 16px 45px;
				gap: 10px;

				.loading-more,
				.message-system {
					font-size: 12px;
					line-height: 20px;
					color: rgba(165, 165, 165, 1);
					text-align: center;
				}

				.message-item {
					width: 100%;

					.avatar-container {
						width: 40px;
						height: 40px;
						border-radius: 10px;
						overflow: hidden;
						background-color: #fff;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.message-content {
						width: calc(100% - 54px);

						.message-name {
							color: rgba(68, 76, 105, 1);
							font-size: 12px;
							font-weight: 400;
							line-height: 16px;

							&.multi-user:hover {
								color: var(--el-kefu-color-primary1);
							}
						}

						.message-time {
							font-size: 12px;
							line-height: 16px;
							color: rgba(165, 165, 165, 1);
						}

						.message-consult,
						.message-text,
						.message-pubg-product-order,
                        .message-sjz-order,
                        .message-sjz-product,
                        .message-sjz-crash,
                        .message-sjz-publish-lease,
						.message-image,
						.message-video {
							width: max-content;
							max-width: calc(100% - 20%);
							background-color: #fff;
							padding: 10px;
							border-radius: 10px;
							position: relative;

							.message-status {
								position: absolute;
								bottom: 10px;
								font-size: 12px;
								line-height: 16px;
								color: rgba(178, 177, 177, 1);
								font-weight: 400;
							}

							.operation-list {
								position: absolute;
								bottom: -40px;
								right: 10px;
								border-radius: 6px;
								padding: 5px;
								background: rgba(255, 255, 255, 1);
								box-shadow: 0px 4px 21px 0px rgba(0, 0, 0, 0.25);
								z-index: 9;

								.operation-list-item {
									color: rgba(61, 61, 61, 1);
									font-size: 12px;
									font-weight: 400;
									line-height: 16px;
									padding: 4px 9px;

									&:hover {
										background: rgba(248, 248, 248, 1);
									}
								}
							}
						}

						.message-consult {
							max-width: 276px;

							.message-consult-title {
								color: rgba(51, 51, 51, 1);
								font-size: 10px;
								font-weight: 400;
								line-height: 14px;
							}

                            .message-consult-content {
                                gap: 10px;
                                border-top: none;

                                .el-collapse-item {
                                    
                                    ::v-deep(.el-collapse-item__header) {
                                        color: var(--el-kefu-color-primary1);
                                        height: 32px;
                                        line-height: 32px;
                                        border-bottom: none;
                                        padding-left: 10px;
                                        border-radius: 5px;
                                        background: rgba(228, 249, 245, 1);

                                        &.is-active {
                                            color: var(--el-kefu-color-primary1);
                                            background: rgba(228, 249, 245, 1);
                                        }
                                    }

                                    ::v-deep(.el-collapse-item__wrap) {
                                        border-bottom: none;
                                    }

                                    ::v-deep(.el-collapse-item__content) {
                                        padding-bottom: 0;
                                        padding-left: 20px;

                                        .kefu-reply-content {
                                            gap: 10px;

                                            &-item {
                                                color: var(--el-kefu-color-primary1);
                                                font-size: 12px;
                                                font-weight: 400;
                                                line-height: 16px;
                                                padding: 4px 8px;
                                                border-radius: 5px;
                                                background: rgba(228, 249, 245, 1);
                                            }
                                        }
                                    }
                                }

                                .message-consult-content-item {
									color: var(--el-kefu-color-primary1);
									font-size: 12px;
									font-weight: 400;
									line-height: 16px;
									padding: 4px 8px;
									border-radius: 5px;
									background: rgba(228, 249, 245, 1);

									.el-icon-arrow-right {
										font-weight: 700;
									}
								}
                            }
						}

						.message-text {
							font-size: 12px;
							line-height: 16px;
							color: rgba(51, 51, 51, 1);
							overflow-wrap: break-word;

							.message-text-content {
								::v-deep(img) {
									max-width: 200px;
									max-height: 150px;
									min-height: 100px;
									border-radius: 5px;
								}
							}
						}

                        // 4: '[商品卡片]',
                        // 5: '[订单卡片]',
                        // 9: '[来源商品卡片]', 客服端是单独的样式
						.message-pubg-product-order {
							.product-number {
								font-size: 12px;
								line-height: 16px;
								color: rgba(51, 51, 51, 1);

								i {
									color: rgba(133, 138, 157, 1);
								}
							}

							.product-info {
								border-radius: 10px;
								background: rgba(247, 248, 250, 1);

								.product-img {
									width: 130px;
									height: 72px;
									border-radius: 10px;
									object-fit: cover;
								}

								.product-name {
									width: 300px;
									font-size: 14px;
									line-height: 19px;
									color: rgba(51, 51, 51, 1);
								}

								.product-tag {
									width: 300px;
									font-size: 12px;
									line-height: 16px;
									color: rgba(165, 165, 165, 1);
								}

								.product-price {
									font-weight: 700;
									font-size: 14px;
									line-height: 19px;
									color: rgba(254, 53, 93, 1);
								}
							}
						}

                        // 13: '[三角洲-商品卡片]',
                        // 14: '[三角洲-订单卡片]',
                        .message-sjz-product,
                        .message-sjz-order {

                            .product-product-number,
                            .product-order-number {
                                font-size: 12px;
								line-height: 16px;
								color: rgba(51, 51, 51, 1);

								i {
									color: rgba(133, 138, 157, 1);
								}
                            }

                            .product-timer {
                                font-size: 12px;
                                line-height: 16px;
                                color: rgba(51, 51, 51, 1);
                            }

                            .product-info {
								border-radius: 10px;
								background: rgba(247, 248, 250, 1);

								.product-img {
									width: 130px;
									// height: 72px;
									height: 94px;
									border-radius: 10px;
									object-fit: cover;
								}

								.product-name {
									width: 300px;
									font-size: 14px;
									line-height: 19px;
									color: rgba(51, 51, 51, 1);
								}

                                .product-status {
                                    font-size: 14px;
                                    color: #e74c3c;
                                }

                                .order-money,
                                .product-money {

                                    &-lable,
                                    &-value {
                                        font-size: 14px;
                                        text-align: left;
                                        color: #606266;
                                    }
                                }
							}
                        }

                        // 15: '[三角洲-撞车卡片]',
                        .message-sjz-crash {
                            &-number {
                                font-size: 12px;
								line-height: 16px;
								color: rgba(51, 51, 51, 1);

								i {
									color: rgba(133, 138, 157, 1);
								}
                            }

                            &-money {
                                font-size: 14px;
                                text-align: left;
                                color: #606266;

                                &-value {
                                    color: rgba(254, 53, 93, 1);

                                    span {
                                        font-size: 12px;
                                    }
                                }
                            }

                            &-info {
								border-radius: 10px;
								background: rgba(247, 248, 250, 1);
                                padding: 5px;

								&-name {
									width: 427px;
									font-size: 14px;
									line-height: 19px;
									color: rgba(51, 51, 51, 1);
								}

                                &-row {
                                    font-size: 14px;
                                    text-align: left;
                                    color: #333;
                                    
                                    &-lable {
                                        color: #606266;
                                    }
                                }
							}
                        }

                        // 16: '三角洲-发布商品卡片',
                        .message-sjz-publish-lease {

                            &-row {
                                &-number {
                                    color: #666;
                                    font-size: 12px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 100%; /* 12px */

                                    span {
                                        color: var(--el-kefu-color-primary1);
                                    }
                                }

                                &-status {
                                    color: #FF9222;
                                    font-size: 12px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 100%; /* 12px */
                                    border-radius: 2px;
                                    padding: 4px 10px;
                                    background: #FFEFDD;
                                }
                            }

                            &-details {
                                &-img {
                                    width: 130px;
                                    max-height: 94px;
                                    border-radius: 10px;
                                    -o-object-fit: cover;
                                    object-fit: cover;
                                }

                                &-info {
                                    &-name {
                                        color: #1F1F23;
                                        font-size: 16px;
                                        font-style: normal;
                                        font-weight: 700;
                                        line-height: 100%; /* 16px */
                                    }

                                    &-tag {
                                        width: 300px;
                                        color: #666;
                                        font-family: "Noto Sans";
                                        font-size: 12px;
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: 16px; /* 12px */
                                    }
                                }
                            }

                            &-status {
                                color: #FF9222;
                                font-size: 12px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 100%; /* 12px */
                                text-align: center;
                                padding: 4px 8px;
                                border-radius: 2px;
                                background: #FFEFDD;
                            }

                            &-price-row {
                                gap: 16px;
                                color: #666;
                                border-radius: 4px;
                                background: #F7F8FA;
                                padding: 10px;  
                                line-height: 16px;

                                &-lable {
                                    font-size: 11px;
                                    font-style: normal;
                                    font-weight: 400;
                                }

                                &-value {
                                    color: #000;
                                    font-size: 14px;
                                    font-style: normal;
                                    font-weight: 500;

                                    span {
                                        font-size: 11px;
                                    }
                                }
                            }
                        }

						.message-image {
							.product-img {
								max-width: 340px;
								min-width: 110px;
								height: 192px;
								border-radius: 10px;
								object-fit: cover;
								object-position: top;
							}
						}

						.message-video {
							.product-video {
								width: 340px;
								height: 192px;
								border-radius: 10px;
							}
						}
					}
				}

				.message-item-you {
					.message-consult,
					.message-text,
					.message-pubg-product-order,
                    .message-sjz-order,
                    .message-sjz-product,
                    .message-sjz-crash,
                    .message-sjz-publish-lease,
					.message-image,
					.message-video {
						float: left;
					}

					.message-status {
						right: -2.5em;
					}
				}

				.message-item-me {
					.message-text,
					.message-pubg-product-order,
                    .message-sjz-order,
                    .message-sjz-product,
                    .message-sjz-crash,
                    .message-sjz-publish-lease,
					.message-image,
					.message-video {
						float: right;
					}

					.message-status {
						left: -2.5em;
					}
				}
			}

			.input-container {
				padding: 8px 22px 8px 16px;
				border-top: 1px solid rgba(221, 225, 230, 1);
				position: relative;

				.tool-box {
					position: absolute;
					top: -34px;
					left: 16px;
					gap: 12px;

					.tool-item {
						border-radius: 4px;
						background: rgba(255, 255, 255, 1);
						padding: 5px 7px;
						font-size: 12px;
						line-height: 16px;
						color: rgba(51, 51, 51, 1);
						gap: 5px;

						.iconfont {
							font-size: 14px;
							line-height: 16px;
							color: var(--el-kefu-color-primary1);
							font-weight: 700;
						}

						&.urge {
							background: var(--el-kefu-color-primary1);
							color: rgba(255, 255, 255, 1);
							font-size: 12px;
							line-height: 16px;

							.iconfont {
								font-size: 16px;
								color: rgba(255, 255, 255, 1);
							}
						}
					}
				}

				.tool-bar {
					gap: 17px;
					position: relative;

					.iconfont {
						font-size: 18px;
						color: rgba(51, 51, 51, 1);
					}

					.icon-video {
						font-size: 19px;
					}
				}

				.textarea-container {
					.custom-editor {
						height: 110px;
						min-height: 110px;
						padding: 5px 0px;
						color: #000;
						background-color: transparent;
						border: transparent;
						overflow-y: auto;
						outline: none; // 去除焦点边框
						font-family: inherit;
						font-size: 14px;
						line-height: 1.5;

						&:empty:before {
							content: attr(placeholder);
							color: #999;
							font-style: normal;
						}

						img {
							max-width: 200px;
							max-height: 150px;
							border-radius: 5px;
							margin: 5px 0;
							vertical-align: middle;
						}
					}
				}

				.btn-container {
					.send-btn {
						font-size: 16px;
						font-weight: 400;
						line-height: 19px;
						padding: 8px 30px;
						border-radius: 10px;
					}

					i {
						font-size: 12px;
						line-height: 16px;
						color: rgba(165, 165, 165, 1);
					}
				}
			}
		}
	}
}
</style>
<style lang="scss">
#kefu-container {
	// 表情弹窗
	.emoji-popover {
		z-index: 9999 !important;
		position: absolute !important;
		left: -14px !important;
		top: -140px !important;

		.popper__arrow {
			left: 16.5px !important;

			&::after {
				top: 126px !important;
				transform: rotate(180deg) !important;
			}
		}

		.emoji-container {
			gap: 2px 5px;

			.emoji-category {
				font-size: 22px;
			}
		}
	}

	// 咨询商品弹窗
	.consult-product-popover {
		position: absolute !important;
		top: -450px !important;
		left: -185px !important;

		.popper__arrow {
			left: 222.5px !important;

			&::after {
				top: 433px !important;
				transform: rotate(180deg) !important;
			}
		}
	}
	// 订单弹窗
	.order-popover {
		position: absolute !important;
		top: -490px !important;
		left: -95px !important;

		.popper__arrow {
			left: 222.5px !important;

			&::after {
				top: 472px !important;
				transform: rotate(180deg) !important;
			}
		}
	}
	// 商品弹窗
	.product-popover {
		position: absolute !important;
		top: -490px !important;
		left: 0px !important;

		.popper__arrow {
            top: -8px !important;
			left: 222.5px !important;

			&::after {
				top: 472px !important;
				transform: rotate(180deg) !important;
			}
		}
	}
	.consult-product-popover,
	.order-popover,
	.product-popover {
		padding: 0px 0px 10px !important;
		z-index: 9999 !important;
		box-shadow: 5px 5px 20px -5px rgba(0, 0, 0, 0.2);
		background: rgba(255, 255, 255, 1);

		.prompt {
			padding: 10px;
			color: rgba(51, 51, 51, 1);
			font-size: 12px;
			font-weight: 400;
			line-height: 16px;
			border-bottom: 1px solid rgba(239, 239, 239, 1);
		}

		.consult-product-popover-tabs,
		.order-popover-tabs,
        .product-popover-tabs {
			padding: 10px 0 0;

			&-item {
				flex: 1;
				color: rgba(51, 51, 51, 1);
				font-size: 12px;
				font-weight: 400;
				line-height: 16px;
                position: relative;

				.iconfont {
					font-size: 12px;
					line-height: 16px;
					font-weight: 700;

					&.icon-a-SafetyProtection_yuechi_key_linear {
						font-size: 16px;
					}

                    &.icon-svg {
                        font-size: 23px;
                        position: absolute;
                        top: 0%;
                    }
				}
			}
		}

        .product-popover-tabs {
            &-item {

                .iconfont.icon-svg {
                    left: 24%;
                }
            }
        }

        .order-popover-tabs {
            &-item {

                .iconfont.icon-svg {
                    left: 5%;
                    // left: 15%;
                }
            }
        }

        &-container {
            padding: 0 10px;
            
            &-empty-container {
                width: 100%;
                height: 100%;

                .iconfont {
                    font-size: 160px;
                    color: var(--el-kefu-color-primary1);
                }
            }

            // 咨询商品、我的商品
            &-list {
                height: 350px;
                overflow-y: auto;

                &-item {
                    padding: 10px 0px;
                    border-bottom: 1px solid rgba(239, 239, 239, 1);

                    &-img,
                    &-sjz-img {
                        width: 170px;
                        height: 95px;
                        border-radius: 10px;
                        object-fit: cover;
                    }

                    &-sjz-img {
                        height: 110px;
                    }

                    &-info,
                    &-sjz-info {
                        width: calc(100% - 170px - 6px);

                        &-name {
                            min-height: 38px;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                        }

                        &-number {
                            color: rgba(165, 165, 165, 1);
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 12px;
                        }

                        &-price {
                            font-family: 'DouyinSans-Bold';
                            color: rgba(254, 53, 93, 1);
                            font-size: 20px;
                            font-weight: 400;
                            line-height: 26px;

                            span {
                                font-size: 14px;
                            }
                        }

                        .el-button {
                            font-size: 12px;
                            padding: 4px 20px;
                            border-radius: 4px;
                        }
                    }
                }
            }

            // 以下订单
            &-pubg-carmi-list {

                &-item {

                    &-img {
                        width: 170px;
                        height: 95px;
                        border-radius: 10px;
                        object-fit: cover;
                    }

                    &-info {

                        &-name {
                            min-height: 38px;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                        }

                        &-number {
                            color: rgba(165, 165, 165, 1);
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 12px;
                        }

                        &-price {
                            font-family: 'DouyinSans-Bold';
                            color: rgba(254, 53, 93, 1);
                            font-size: 20px;
                            font-weight: 400;
                            line-height: 26px;

                            span {
                                font-size: 14px;
                            }
                        }
                    }
                }
            }

            &-sjz-rental-list {

                &-item {

                    &-time {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 12px;
                        color: #555;
                    }

                    &-img {
                        width: 170px;
                        height: 110px;
                        border-radius: 10px;
                        object-fit: cover;
                    }

                    &-info {

                        &-name {
                            // min-height: 38px;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                        }

                        &-status {
                            font-size: 14px;
                            color: #e74c3c;
                        }

                        &-detail {
                            color: #55575b;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 14px;

                            &-lable,
                            &-value {
                                text-align: left;
                            }
                        }
                    }
                }
            }

            &-sjz-crash-list {

                &-item {

                    &-name {
                        color: rgba(51, 51, 51, 1);
						font-size: 14px;
						font-weight: 400;
						line-height: 20px;
                    }

                    &-price {
                        padding: 5px 10px;
                        background-image: linear-gradient(270deg, #fff 0, rgba(0, 184, 107, .1) 100%);
                        border: 1px solid rgba(0, 184, 107, .4);
                        border-radius: 4px;

                        &-lable {
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 12px;
                        }

                        &-value {
                            font-family: 'DouyinSans-Bold';
                            color: rgba(254, 53, 93, 1);
                            font-size: 20px;
                            font-weight: 400;
                            line-height: 26px;

                            span {
                                font-size: 14px;
                            }
                        }
                    }

                    &-row {
                        color: #55575b;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 14px;

                        &-lable,
                        &-value {
                            text-align: left;
                        }
                    }
                }
            }

            &-pubg-carmi-list,
            &-sjz-rental-list,
            &-sjz-crash-list {
                height: 350px;
                overflow-y: auto;

                &-item {
                    padding: 10px 0px;
				    border-bottom: 1px solid rgba(239, 239, 239, 1);

                    &-no {
                        color: rgba(51, 51, 51, 1);
						font-size: 14px;
						font-weight: 400;
						line-height: 20px;
                    }

                    &-info {
                        width: calc(100% - 170px - 6px);
                    }

                    .el-button--primary {
                        font-size: 12px;
                        padding: 4px 20px;
                        border-radius: 4px;
                    }
                }
            }
        }
	}
}
</style>
